import React from "react";
// import { useState, useEffect } from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, joinAuction } from "../../actions/index";
import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";
import { playerdefaultLogo } from "../../constants/Images";
import { useMediaQuery } from "react-responsive";
import ImageCropper from "../cropper/ImageCropper";
import { bat } from "../../constants/Images";
import { ball } from "../../constants/Images";
import { wkeeper, qr1 } from "../../constants/Images";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from "../utils/Demo";
import { useSpecState } from "./SpecContext.jsx";
import styled from "styled-components";
import moment from "moment";
import { Copy, Check } from "lucide-react";
import ExternalDataService from "../../services/external.service";
// Banner image import removed - now using dynamic banner from API

// Styled components for QR payment section
const QRContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  background-color: #f9f9f9;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`;

const QRImageWrapper = styled.div`
  text-align: left;
  margin-right: 20px;
  @media (max-width: 767px) {
    margin-right: 0;
    margin-bottom: 20px;
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const QRImage = styled.img`
  width: 150px;
  height: 150px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 5px;
  background-color: white;
`;

const QRDetailsWrapper = styled.div`
  flex: 1;
  text-align: left;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const QRSectionTitle = styled.h4`
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
`;

const QRDetailRow = styled.div`
  margin-bottom: 8px;
`;

const QRDetailLabel = styled.label`
  font-weight: bold;
  color: #555;
  display: inline-block;
  width: auto;
  margin-right: 10px;
`;

const QRDetailValue = styled.span`
  color: #333;
`;

const QRFeeValue = styled.span`
  color: #e53e3e;
  font-weight: bold;
`;

const QRInstructions = styled.div`
  margin-top: 15px;
  font-size: 13px;
  color: #666;
`;

// File Upload Styling
const fileUploadStyles = `
  .receipt-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
  }
  
  .required-asterisk {
    color: red;
  }
  
  .file-upload-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
    transition: all 0.3s ease;
  }
  
  .file-upload-container:hover {
    border-color: #999;
    background-color: #f0f0f0;
  }
  
  .upload-icon {
    margin-bottom: 10px;
    color: #666;
  }
  
  .upload-text {
    margin: 0 0 10px 0;
    font-size: 14px;
    color: #666;
    text-align: center;
  }
  
  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  
  .error-message {
    color: red;
    font-size: 12px;
    margin-top: 5px;
  }
  
  .file-size-limit {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    font-style: italic;
    text-align: center;
  }
`;

export default function JoinauctionCode3() {
  const [isDisabled, setDisabled] = useState(false);
  // const getpageData = useSelector((state) => state.setJoinAuction);
  const loginuser = useSelector((state) => state.setUserlog);
  const aucmoredetail = useSelector((state) => state.actmoredata);

  // Add state to control view (landing vs form)
  const [showForm, setShowForm] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  // Move all useState hooks to the top level and initialize with safe default values
  // const [isDisabled, setDisabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [othersp3, setOthersp3] = useState(false);
  const [sp3, setsp3] = useState("");
  const [batting, setBatting] = useState("none");
  const [getpageData, setgetpageData] = useState(null);
  const [otherBatting, setOtherBatting] = useState(0);
  const [otherBowling, setOtherBowling] = useState(0);
  const [bowling, setBowling] = useState(0);
  const [cid, setCid] = useState(loginuser?.cid || "");
  const [catData, setcatData] = useState([]);
  const [isjoinanother, setisjoinanother] = useState(false);
  const [catid, setcatid] = useState("");
  const [isbat, setisbat] = useState(false);
  const [isbol, setisbol] = useState(false);
  const [iswkeep, setiswkeep] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");
  const [isregon, setisregon] = useState(false);
  const [defimg, setdefimg] = useState(playerdefaultLogo);
  const [defimg2, setdefimg2] = useState("");
  const [auctype, setauctype] = useState("0");
  const [data, setData] = useState(null);
  const [date, setDate] = useState(null);
  const [pyqr, setPyqr] = useState(null);
  const [path, setpath] = useState("");
  const [paymentData, setPaymentData] = useState(null);
  const [playingStyle, setPlayingStyle] = useState("");
  const [selectedReceiptFile, setSelectedReceiptFile] = useState(null);
  const { state, setState, updateState, addItem, removeOption } =
    useSpecState();
  const [savedFilename, setSavedFilename] = useState(defimg2 || "");


  // Static options that don't need to be updated
  const sp1opt = [
    "All Rounder",
    "Batting All Rounder",
    "Bowling All Rounder",
    "All Rounder Wicketkeeper",
    "Batsman",
    "Bowler",
    "Wicket Keeper",
    "Batter",
    "Other",
  ];

  const sp2opt = [
    "Right Hand",
    "Left Hand",
    "Right Hand Batsman",
    "Left Hand Batsman",
    "Right Hand Opener",
    "Left Hand Opener",
    "Right Hand Middle Order",
    "Left Hand Middle Order",
  ];

  const sp3opt = [
    "Right Arm Fast",
    "Right Arm Medium",
    "Left Arm Fast",
    "Left Arm Medium",
    "Off-Break",
    "Leg-Break",
    "Left Arm Orthodox",
    "Left Arm Chinaman",
  ];
  const handleFileUpload = async (e, index) => {
    const aid = localStorage.getItem("auction_id");
    const file = e.target.files[0];
    if (!file) return;

    try {
      // STEP 1: Ask backend for presigned URL
      const form = new FormData();
      form.append("filename", file.name);
      form.append("fltyp", "receipt");
      const hdr = {
        headers: {
          authorization: JSON.stringify([
            { cid, aid, token: loginuser["token"] }
          ]),
        },
      };

      const getUrlRes = await ExternalDataService.getSignedUrl(form, hdr);

      if (!getUrlRes.data.success) {
        throw new Error("Failed to get presigned URL");
      }

      const { presignedUrl, filename } = getUrlRes.data.data;

      // STEP 2: Upload to S3
      const uploadRes = await fetch(presignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
          "x-amz-acl": "public-read",
        },
        body: file,
      });

      if (!uploadRes.ok) throw new Error("Upload failed");

      // STEP 3: Store only uploaded filename in react-hook-form
      setValue(`extra_${index}`, filename, { shouldValidate: true });

      toast.success("File uploaded!", { theme: "colored" });

    } catch (err) {
      console.error("Upload error:", err);
      toast.error(err.message || "Upload failed");
    }
  };

  // Initialize these after getpageData is loaded
  const [joinauctionAid, setjoinauctionAid] = useState(null);
  const [auctionCode, setauctionCode] = useState(null);
  const [helpline, sethelpline] = useState(null);
  const [helplineEntries, setHelplineEntries] = useState([]);

  // Media query hooks
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const isMobileOnly = useMediaQuery({ query: "(max-width: 768px)" });

  // Router hook
  const history = useHistory({ forceRefresh: true });
  var savenew = 0;
  let logo_pic = "";

  // const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchallData = (values) => {
    //  // console.log('fetching api')

    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: 0, token: 0 }]),
      },
    };
    //  // console.log("")
    DataService.JoinauctionCode(values, hdr)
      .then((res) => {
        let response = res.data;
        // console.log(values);
        // console.log("response is.....");
        // console.log(response);
        if (response.data.detail.reg_player_on == "1") {
          setisregon(true);
        }
        setauctype(response.data.detail.acttype);
        sethelpline(response.data.club);

        // Parse helpline JSON array if available
        if (response.data.helpline) {
          try {
            let helplineData = response.data.helpline;
            // Parse if it's a string
            if (typeof helplineData === 'string') {
              helplineData = JSON.parse(helplineData);
            }

            if (Array.isArray(helplineData) && helplineData.length > 0) {
              setHelplineEntries(helplineData);
            } else {
              setHelplineEntries([]);
            }
          } catch (error) {
            console.error("Error parsing helpline JSON:", error);
            setHelplineEntries([]);
          }
        } else {
          setHelplineEntries([]);
        }

        toast.dismiss(toastContainerId);
        setgetpageData({ response, values });

        // dispatch(joinAuction({ response, values }));

        // if (response.success == true) {
        // if (response.data.detail.reg_player_on === "1") {
        //   //  // console.log("code submit")
        //   //  // console.log(response.data)
        //   localStorage.setItem("auction_id", response.data.detail.aid);

        //   toast.success("Now you can Join", {
        //     theme: "dark",
        //     position: "bottom-center",
        //   });
        //   history.push(BASE_PATH + "join-auction");
        // }
        // else {
        //   setjoindata(response.data.detail)
        // }

        // } else {
        //   toast.error(response.msg, { theme: "colored" });
        // }

        // setDisabled(false);
      })
      .catch(() => {
        //  // console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Serverrr Error", { theme: "colored" });
        setDisabled(false);
      });
    // localStorage.removeItem('acode')
  };

  const [iscopied10, setIscopied10] = useState(false);
  const formlinkcopy10 = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setIscopied10(true);
      setTimeout(() => setIscopied10(false), 1000);
    } catch (err) {
      console.error("Copy failed:", err);
      alert("Copy failed! Please select and copy manually.");
    }
  };

  const [iscopied11, setIscopied11] = useState(false);
  const formlinkcopy11 = async (textToCopy) => {
    console.log(textToCopy);

    try {
      await navigator.clipboard.writeText(textToCopy);
      setIscopied11(true);
      setTimeout(() => setIscopied11(false), 1000);
    } catch (err) {
      console.error("Copy failed:", err);
      alert("Copy failed! Please select and copy manually.");
    }
  };

  // Function to handle Pay Now button - opens payment apps (original working version)
  // const handlePayNow = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   // 1. Basic validations
  //   if (!pyqr || !pyqr.mob) {
  //     toast.error("UPI ID not found", { theme: "colored" });
  //     return;
  //   }

  //   const upiId = pyqr.mob.trim();
  //   const merchantName = "Harsh Technology"; // fixed naam bhi chal jayega
  //   let amount = Number(pyqr.fee);

  //   if (isNaN(amount) || amount <= 0) {
  //     toast.error("Invalid amount", { theme: "colored" });
  //     return;
  //   }

  //   // 2. Generate unique transaction reference
  //   const txnId = `TXN${Date.now()}${Math.floor(Math.random() * 1000)}`;

  //   // 3. Build UPI deep link
  //   const upiLink =
  //     `upi://pay?` +
  //     `pa=${encodeURIComponent(upiId)}` +
  //     `&pn=${encodeURIComponent(merchantName)}` +
  //     `&tr=${txnId}` +
  //     `&am=${amount.toFixed(2)}` +
  //     `&cu=INR`;

  //   console.log("UPI Payment Link:", upiLink);

  //   // 4. Open UPI app
  //   try {
  //     window.location.href = upiLink;
  //     toast.success("Opening payment app...", { theme: "colored" });
  //   } catch (error) {
  //     console.error("UPI open error:", error);
  //     toast.error("Could not open payment app", { theme: "colored" });
  //   }
  // };


  const fetchcatData = async (aid) => {
    // setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: 0, token: 0 }]),
      },
    };

    await DataService.listCategory({ aid: aid }, hdr)

      .then((res) => {
        //  // console.log('categories response')
        //  // console.log(res)
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;
          //  // console.log(responsedata);
          setcatData(responsedata.list);
        }
        // setActive(false);
      })
      .catch(() => {
        //  // console.log('Not valid')
        // setActive(false);
      });
  };

  // useEffect(() => {
  //   const storedState = localStorage.getItem("savedState");
  //   if (storedState) {
  //     const parsedState = JSON.parse(storedState);
  //     setState((prevState) => ({
  //       ...prevState,
  //       sp1Opt: parsedState.sp1Opt || [],  // Update sp1Opt dynamically
  //       sp2Opt: parsedState.sp2Opt || [],
  //       sp3Opt: parsedState.sp3Opt || [],
  //     }));
  //   }
  // }, []);

  useEffect(() => {
    localStorage.setItem("crp_typ", 0);
    var values = {
      acode: localStorage.getItem("acode"),
    };
    //  // console.log('initial state')
    // console.log(localStorage.getItem("auction_id"));
    // const auc_id = localStorage.getItem("acode").split("-")[0];
    // localStorage.setItem("auction_id", auc_id);
    // console.log("auc_id");
    // console.log(auc_id);
    fetchallData(values);
  }, []);
  useEffect(() => {
    const fileInput = document.getElementById("receipt-file-input");
    const container = fileInput?.closest(".file-upload-container");

    if (fileInput) {
      fileInput.addEventListener("change", function () {
        if (this.files && this.files.length > 0) {
          container.classList.add("has-file");
        } else {
          container.classList.remove("has-file");
        }
      });
    }

    return () => {
      if (fileInput) {
        fileInput.removeEventListener("change", () => { });
      }
    };
  }, []);
  useEffect(() => {
    // console.log("get page data ");
    // console.log(getpageData);
    if (getpageData) {
      // console.log("ddkeidekid");
      // console.log(getpageData);
      localStorage.setItem("auction_id", getpageData.response.data.detail.aid);
      // console.log("getpageData.response.data.detail");
      // console.log(getpageData.response.data);
      // console.log(getpageData.response.data);
      setData(getpageData.response.data.detail);
      // Fetch isaucdthide from platforminfo if available, otherwise from direct data
      const isaucdthideValue = getpageData.response.data.platforminfo?.isaucdthide ||
        getpageData.response.data.isaucdthide ||
        "0";
      setDate(isaucdthideValue);
      console.log("___________ isaucdthide:", isaucdthideValue);

      setPyqr(getpageData.response.data.pyqr);
      setpath(getpageData.response.data.path);
      setPaymentData(getpageData.response.data);
      // fetchcatData(getpageData.response.data.detail.aid)
      setcatData(getpageData.response.data.detail.catlist);
    }
  }, [getpageData]);
  useEffect(() => {
    if (loginuser) {
      if (loginuser.photo) {
        setdefimg(loginuser.photo);
        setdefimg2(loginuser.photo.split("/")[4]);
      }
      setValue("pname", loginuser.cperson);
      setValue("mobno", loginuser.mobno);
      setValue("fname", loginuser.fname);
    }
  }, [loginuser]);

  const onSubmit = async (values) => {
    if (isSubmitting) return; // ❗Ultimate double-click protection
    setIsSubmitting(true);

    try {
      // setIsSubmitting(true);
      // setDisabled(true);

      if (croppedImage == "" && defimg == playerdefaultLogo) {
        alert("Please add your profile picture !!");
        setIsSubmitting(false);
        setDisabled(false);
        return;
      }

      const formData = new FormData();

      // Add all regular form values to FormData
      Object.keys(values).forEach((key) => {
        if (key !== "receipt" && key !== "utrno") {
          // Skip receipt (handled separately); utrno appended below with key "utrno" for join-player
          formData.append(key, values[key]);
        }
      });
      // Join-player API: send UTR value with key "utrno"
      formData.append("utrno", values.utrno != null && values.utrno !== "" ? String(values.utrno).trim() : "");

      // Handle receipt file if it exists
      if (values.receipt && values.receipt[0]) {
        // console.log("receipt file exists");
        // console.log(values.receipt[0]);

        // Additional file size validation for security
        const file = values.receipt[0];
        const fileSizeInMB = Number((file.size / (1024 * 1024)).toFixed(2));

        if (fileSizeInMB > 2) {
          toast.error("File size must be less than 2MB", {
            theme: "colored",
            position: "bottom-center",
          });
          setIsSubmitting(false);
          setDisabled(false);
          return;
        }

        formData.append("receipt", file);
      }
      const aid = localStorage.getItem("auction_id");
      // Handle profile picture
      if (croppedImage === "") {
        formData.append("img", defimg2);
      } else if (savedFilename !== "") {
        formData.append("img", savedFilename);
      } else {
        // Use auction detail (aucmoredetail) from Redux – already loaded from /dataapi/auction/detail for this aid; no extra API call.
        // data.no_presignimg === 1 → bypass S3, direct server upload; otherwise use S3 presigned.
        const noPresignImg = aucmoredetail?.data?.no_presignimg ?? aucmoredetail?.no_presignimg;
        if (noPresignImg === 1) {
          // Same key as Add/Edit player so backend saves image and sets img (visible in Editplayers/Players)
          formData.append("logo_pic", croppedImage);
        } else {
          try {
            const blob = await fetch(croppedImage).then((res) => res.blob());
            const fileName = `profile_${Date.now()}.jpg`;
            const file = new File([blob], fileName, {
              type: blob.type || "image/jpeg",
            });

            const urlForm = new FormData();
            urlForm.append("filename", file.name);
            urlForm.append("fltyp", "playerimg");

            const hdr = {
              headers: {
                authorization: JSON.stringify([
                  { cid, aid, token: loginuser["token"] },
                ]),
              },
            };

            const getUrlRes = await ExternalDataService.getSignedUrl(
              urlForm,
              hdr
            );
            if (!getUrlRes.data.success) {
              throw new Error("Failed to get upload URL");
            }

            const { presignedUrl, filename } = getUrlRes.data.data;

            const uploadRes = await fetch(presignedUrl, {
              method: "PUT",
              headers: {
                "Content-Type": file.type,
                "x-amz-acl": "public-read",
              },
              body: file,
            });

            if (!uploadRes.ok) {
              const err = await uploadRes.text();
              throw new Error("Upload failed: " + err);
            }

            formData.append("img", filename);
            setSavedFilename(filename);

            toast.success("Logo uploaded successfully!", { theme: "colored" });
          } catch (error) {
            console.error("Logo upload error:", error);
            toast.error(error.message || "Failed to upload logo");
            setDisabled(false);
            return;
          }
        }
      }

      // Handle icons
      var icon = "";
      if (isbat == true) {
        if (icon == "") {
          icon += "bat.png";
        } else {
          icon += ",bat.png";
        }
      }
      if (isbol == true) {
        if (icon == "") {
          icon += "ball.png";
        } else {
          icon += ",ball.png";
        }
      }
      if (iswkeep == true) {
        if (icon == "") {
          icon += "gloves.png";
        } else {
          icon += ",gloves.png";
        }
      }
      formData.append("icons", icon);

      // Handle specification 3 for auction type 0
      if (auctype == 0) {
        formData.append("spcf3", sp3);
      }

      var hdr = {
        headers: {
          "Content-Type": "multipart/form-data", // Changed to multipart/form-data
          authorization: JSON.stringify([
            { cid: 0, token: 0, aid: localStorage.getItem("auction_id") },
          ]),
        },
      };

      const id = toast.loading("Please wait...");
      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
      });

      // console.log("Submitting form data...");
      await DataService.joinPlayer(formData, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);

          if (response.success == true) {
            let submitdata = [response.data.new];

            toast.success("Successfully Joined", {
              theme: "dark",
              position: "bottom-center",
            });
            localStorage.setItem("cjoined", data.auctionname);
            localStorage.setItem("cjoined_player_name", values.pname);
            localStorage.setItem("cjoined_player_mobno", values.mobno);
            localStorage.setItem(
              "cjoined_helpline_mob",
              paymentData &&
                paymentData.helpline_mob &&
                paymentData.helpline_mob.trim() !== ""
                ? paymentData.helpline_mob
                : helpline.mobno
            );
            localStorage.setItem(
              "cjoined_helpline_name",
              paymentData &&
                paymentData.helpline_name &&
                paymentData.helpline_name.trim() !== ""
                ? paymentData.helpline_name
                : helpline.cperson
            );
            savenew
              ? reset()
              : history.push(`${BASE_PATH}join-auction-success`);
          } else {
            toast.error(response.msg, { theme: "colored" });
          }
        })
        .catch((error) => {
          toast.dismiss(toastContainerId);

          console.error("❌ JOIN PLAYER API ERROR");

          if (error.response) {
            // ✅ Server ne response diya but error status ke saath
            console.error("Status:", error.response.status);
            console.error("Headers:", error.response.headers);
            console.error("Response Data:", error.response.data);

            toast.error(
              error.response.data?.msg ||
              error.response.data?.message ||
              "Server Error",
              { theme: "colored" }
            );
          }
          else if (error.request) {
            // ❌ Request gayi but response nahi aaya
            console.error("No response received:", error.request);

            toast.error("No response from server", { theme: "colored" });
          }
          else {
            // ❌ Request banate time error
            console.error("Error Message:", error.message);

            toast.error(error.message, { theme: "colored" });
          }
        })

        .finally(() => {
          setIsSubmitting(false);
          // setDisabled(false);
        });
    } catch (error) {
      setIsSubmitting(false);
      setDisabled(false);
      toast.error("An error occurred", { theme: "colored" });
    }
  };

  var batstyle = {
    backgroundColor: "white",
  };
  var bolstyle = {
    backgroundColor: "white",
  };
  var wkeepstyle = {
    backgroundColor: "white",
  };
  if (isbat == true) {
    batstyle = {
      backgroundColor: "black",
      color: "white",
      border: "3px solid blue",
    };
  }
  if (isbol == true) {
    bolstyle = {
      backgroundColor: "black",
      color: "white",
      border: "3px solid blue",
    };
  }
  if (iswkeep == true) {
    wkeepstyle = {
      backgroundColor: "black",
      color: "white",
      border: "3px solid blue",
    };
  }
  return (
    <div className="join-auction-page">
      {/* <Navigationtitle data={match} /> */}
      <style>{fileUploadStyles}</style>
      <style>{`
      .fields-section{
      padding-top:12px;
      }
        .full-width-page {
          width: 100% !important;
          max-width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .full-width-container {
          width: 100% !important;
          max-width: 100% !important;
          margin: 0 !important;
          padding: 0 15px !important;
        }
        .full-width-row {
          width: 100% !important;
          margin: 0 !important;
        }
        .full-width-form {
          width: 100% !important;
          max-width: 100% !important;
        }
        /* Override Bootstrap container constraints */
        .container-fluid {
          max-width: 100% !important;
          width: 100% !important;
        }
        .row {
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
        .col-md-12 {
          width: 100% !important;
          max-width: 100% !important;
        }
        /* Ensure form takes full width */
        .reg-area, .reg-area2 {
          width: 100% !important;
          max-width: 100% !important;
        }
        .join-auction-form {
          width: 100% !important;
          max-width: 100% !important;
        }
        .reg-items {
          width: 100% !important;
          max-width: 100% !important;
        }
        .reg-form {
          width: 100% !important;
          max-width: 100% !important;
        }
        
        .no-side-padd-lap{
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
                /* Mobile responsive banner styles */
        @media (max-width: 768px) {
          .banner-image-mobile {
            width: 100% !important;
            height: 56.25vw !important; /* 16:9 aspect ratio */
            border-radius: 12px !important;
            border: none !important;
            margin: 0 !important;
            padding: 0 !important;
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            transform: none !important;
            z-index: 1 !important;
          }
          .banner-image-mobile.banner-image-mobile-tall {
            height: 84.25vw !important;
          }
          .banner-section.banner-section-tall {
            height: 84.25vw !important;
          }
          .banner-section {
            position: relative !important;
            width: 88vw !important;
            height: 56.25vw !important;
            margin: 0 !important;
            padding: 0 !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
            overflow: hidden !important;
          }
          
          .landing-page-mobile {
            padding: 0 !important;
            margin: 0 !important;
            position: relative !important;
            margin-top: 0 !important;
            padding-top: 0 !important;
            overflow: visible !important;
            min-height: auto !important;
          }
          .reg-area.full-width-page,
          .full-width-container,
          .join-auction-page {
            overflow: visible !important;
          }
          
          .auction-info-mobile {
            margin-top: 0 !important;
            padding-top: 20px !important;
            text-align: center !important;
            position: relative !important;
            z-index: 2 !important;
            background: white !important;
            padding-left: 20px !important;
            padding-right: 20px !important;
            padding-bottom: 20px !important;
          }
          
          /* Override any Bootstrap margins/padding on mobile */
          .col-md-6 {
            padding: 0 !important;
            margin: 0 !important;
          }
          
          .row {
            margin: 0 !important;
            padding: 0 !important;
          }
          .landing-page-mobile .row {
            min-height: auto !important;
          }
          
          /* Ensure main container starts from top on mobile */
          .full-width-page {
            margin-top: 0 !important;
            padding-top: 0 !important;
          }
          
          .full-width-container {
            margin-top: 0 !important;
            padding-top: 0 !important;
          }
          
          /* Remove any top spacing from parent containers */
          .container-fluid {
            margin-top: 10px !important;
            padding-top: 0 !important;
          }
          
          /* Ensure the main page starts from very top */
          .join-auction-page {
            margin-top: 0 !important;
            padding-top: 0 !important;
          }
          
          /* Force remove all top spacing on mobile */
          * {
            margin-top: 0 !important;
          }
          
          /* Specific override for the main page */
          body .join-auction-page {
            margin-top: 0 !important;
            padding-top: 0 !important;
          }
          
          /* Remove left-right padding for all column elements on mobile */
          .no-side-padd {
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
          
          /* Ensure form elements take full width on mobile */
          .no-side-padd .form-control,
          .no-side-padd input,
          .no-side-padd select,
          .no-side-padd textarea {
            // width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
          }
                .reg-area .reg-items .reg-form{
                  padding-left: 0 !important;
                  padding-right: 0 !important;
                }
                
        }
      `}</style>

      {getpageData ? (
        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less full-width-page"
        >
          <div className="container-fluid full-width-container">
            <div className="row full-width-row">
              <div
                id="contact-us"
                className="reg-area reg-area2 full-width-page"
              >
                <div className="container-fluid full-width-container">
                  {/* Landing Page View */}
                  {!showForm && (
                    <div
                      className="landing-page landing-page-mobile"
                      style={{ padding: "40px 20px" }}
                    >
                      <div
                        className="row"
                        style={{
                          alignItems: "center",
                          minHeight: "500px",
                          margin: 0,
                          paddingTop: 0,
                        }}
                      >
                        {/* Left Half - Banner Image - Only show if banner data exists */}
                        {getpageData &&
                          getpageData.response.data.banner &&
                          getpageData.response.data.banner.img &&
                          getpageData.response.data.bnpath && (
                            <div
                              className="col-md-6"
                              style={{ textAlign: "center" }}
                            >
                              <div
                                className={
                                  "banner-section" +
                                  (localStorage.getItem("auction_id") === "62334"
                                    ? " banner-section-tall"
                                    : "")
                                }
                              >
                                <img
                                  src={
                                    getpageData.response.data.bnpath +
                                    getpageData.response.data.banner.img
                                  }
                                  alt="Auction Banner"
                                  className={
                                    "banner-image-mobile" +
                                    (localStorage.getItem("auction_id") === "62334"
                                      ? " banner-image-mobile-tall"
                                      : "")
                                  }
                                  style={{
                                    maxWidth: "100%",
                                    height: "400px",
                                    objectFit: "contian",
                                    border: "3px solid #186cc2",
                                    borderRadius: "20px",
                                    boxShadow:
                                      "0 8px 25px rgba(24, 108, 194, 0.3), 0 4px 10px rgba(0, 0, 0, 0.1)",
                                    transition: "all 0.3s ease",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.style.display = "none";
                                  }}
                                />
                              </div>
                            </div>
                          )}

                        {/* Right Half - Auction Logo and Info */}
                        <div
                          className={
                            getpageData &&
                              getpageData.response.data.banner &&
                              getpageData.response.data.banner.img &&
                              getpageData.response.data.bnpath
                              ? "col-md-6"
                              : "col-md-12"
                          }
                          style={{ textAlign: "center" }}
                        >
                          <style>{`
                            @keyframes fadeInUp {
                              from {
                                opacity: 0;
                                transform: translateY(20px);
                              }
                              to {
                                opacity: 1;
                                transform: translateY(0);
                              }
                            }
                            @keyframes fadeInScale {
                              from {
                                opacity: 0;
                                transform: scale(0.9);
                              }
                              to {
                                opacity: 1;
                                transform: scale(1);
                              }
                            }
                            @keyframes pulse {
                              0%, 100% {
                                transform: scale(1);
                              }
                              50% {
                                transform: scale(1.05);
                              }
                            }
                            .auction-logo-animated {
                              animation: fadeInScale 0.6s ease-out;
                            }
                            .auction-title-animated {
                              animation: fadeInUp 0.6s ease-out 0.2s both;
                            }
                            .auction-info-animated {
              animation: fadeInUp 0.6s ease-out 0.4s both;
            }
            .auction-fee-animated {
              animation: fadeInUp 0.6s ease-out 0.5s both;
            }
            .auction-helpline-animated {
              animation: fadeInUp 0.6s ease-out 0.6s both;
            }
            .auction-button-animated {
              animation: fadeInUp 0.6s ease-out 0.8s both;
            }
            .hover-lift {
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }
            .hover-lift:hover {
              transform: translateY(-3px);
            }
            .icon-bounce {
              display: inline-block;
              transition: transform 0.2s ease;
            }
            .icon-bounce:hover {
              transform: scale(1.2) rotate(5deg);
            }
                          `}</style>
                          <div className="auction-info-landing auction-info-mobile">
                            {data && (
                              <div className="auction-details">
                                <div
                                  className="auction-logo auction-logo-animated"
                                  style={{
                                    marginBottom: "20px",
                                    display: "flex",
                                    justifyContent: "center"
                                  }}
                                >
                                  <Image
                                    src={
                                      data && data.alogo != null
                                        ? path + data.alogo
                                        : auctiondefaultLogo
                                    }
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = auctiondefaultLogo;
                                    }}
                                    fallback={
                                      <Shimmer max-width={110} height={110} />
                                    }
                                    className="hover-lift"
                                    style={{
                                      maxWidth: "110px",
                                      height: "110px",
                                      borderRadius: "50%",
                                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.boxShadow = "0 8px 20px rgba(24, 108, 194, 0.3)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
                                    }}
                                  />
                                </div>
                                <div className="auction-text" style={{ textAlign: "center" }}>
                                  <h2
                                    className="auction-title-animated"
                                    style={{
                                      color: "#186cc2",
                                      marginBottom: "18px",
                                      fontSize: "30px",
                                      fontWeight: "600",
                                      letterSpacing: "0.3px",
                                      lineHeight: "1.4",
                                      transition: "color 0.3s ease",
                                    }}
                                  >
                                    {data.auctionname}
                                  </h2>

                                  {localStorage.getItem("auction_id") !==
                                    "51199" &&
                                    localStorage.getItem("auction_id") !==
                                    "56396" &&
                                    date !== "1" && (
                                      <p
                                        className="auction-info-animated hover-lift"
                                        style={{
                                          fontSize: "18px",
                                          marginBottom: "16px",
                                          color: "#4a5568",
                                          fontWeight: "500",
                                          display: "block",
                                          padding: "8px 16px",
                                          borderRadius: "8px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.backgroundColor = "#f7fafc";
                                          e.target.style.color = "#2d3748";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.backgroundColor = "transparent";
                                          e.target.style.color = "#4a5568";
                                        }}
                                      >
                                        <span className="icon-bounce" style={{ marginRight: "8px" }}>📅</span>
                                        Auction on: <strong style={{ color: "#2d3748" }}>{data.dt}</strong>
                                      </p>
                                    )}

                                  {/* Registration Fee - show for 60744, 61748, 62590, or when pyqr.fee is set */}
                                  {(localStorage.getItem("auction_id") === "62590" ||
                                    (pyqr && pyqr.fee !== null && pyqr.fee !== undefined && pyqr.fee !== "" && String(pyqr.fee).trim() !== "" && String(pyqr.fee).trim() !== "0" && !isNaN(Number(pyqr.fee)) && Number(pyqr.fee) > 0)) && (
                                      localStorage.getItem("auction_id") === "62590" ? (
                                        <div
                                          className="auction-fee-animated hover-lift"
                                          style={{
                                            fontSize: "18px",
                                            marginBottom: "16px",
                                            color: "#2d5016",
                                            fontWeight: "600",
                                            display: "block",
                                            padding: "8px 16px",
                                            borderRadius: "8px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#f0fff4";
                                            e.currentTarget.style.color = "#22543d";
                                            e.currentTarget.style.transform = "scale(1.02)";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                            e.currentTarget.style.color = "#2d5016";
                                            e.currentTarget.style.transform = "scale(1)";
                                          }}
                                        >
                                          <span className="icon-bounce" style={{ marginRight: "8px" }}>💰</span>
                                          <div style={{ marginTop: "4px" }}>
                                            <div>Registration Fee(Gramin): <strong style={{ color: "#22543d", fontSize: "20px" }}>₹800</strong></div>
                                            <div style={{ marginTop: "4px" }}>Registration Fee(City): <strong style={{ color: "#22543d", fontSize: "20px" }}>₹1000</strong></div>
                                          </div>
                                        </div>
                                      ) : (
                                        <p
                                          className="auction-fee-animated hover-lift"
                                          style={{
                                            fontSize: "18px",
                                            marginBottom: "16px",
                                            color: "#2d5016",
                                            fontWeight: "600",
                                            display: "block",
                                            padding: "8px 16px",
                                            borderRadius: "8px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = "#f0fff4";
                                            e.target.style.color = "#22543d";
                                            e.target.style.transform = "scale(1.02)";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = "transparent";
                                            e.target.style.color = "#2d5016";
                                            e.target.style.transform = "scale(1)";
                                          }}
                                        >
                                          <span className="icon-bounce" style={{ marginRight: "8px" }}>💰</span>
                                          Registration Fee: <strong style={{ color: "#22543d", fontSize: "20px" }}>
                                            {localStorage.getItem("auction_id") === "60744"
                                              ? "AED.50"
                                              : localStorage.getItem("auction_id") === "61748"
                                                ? (pyqr && pyqr.fee && String(pyqr.fee).trim() !== "" ? (pyqr.fee.toString().startsWith("₹") ? pyqr.fee : `₹${pyqr.fee}`) : "₹500 / ₹1000")
                                                : (pyqr && pyqr.fee ? `₹${pyqr.fee}` : "")}
                                          </strong>
                                        </p>
                                      )
                                    )}

                                  {localStorage.getItem("auction_id") !== "58500" && (
                                    <div>
                                      {/* Display helpline entries from JSON array */}
                                      {helplineEntries && helplineEntries.length > 0 ? (
                                        <>
                                          <p
                                            className="auction-helpline-animated hover-lift"
                                            style={{
                                              fontSize: "17px",
                                              color: "#4a5568",
                                              marginBottom: "16px",
                                              fontWeight: "500",
                                              display: "block",
                                              padding: "8px 16px",
                                              borderRadius: "8px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.target.style.backgroundColor = "#f7fafc";
                                              e.target.style.color = "#2d3748";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.target.style.backgroundColor = "transparent";
                                              e.target.style.color = "#4a5568";
                                            }}
                                          >
                                            <span style={{ display: isTabletOrMobile ? "block" : "inline" }}>
                                              <span className="icon-bounce" style={{ marginRight: "8px" }}>📞</span>
                                              Need Help :
                                            </span>
                                          </p>
                                          {helplineEntries.map((entry, index) => (
                                            <p
                                              key={index}
                                              className="auction-helpline-animated hover-lift"
                                              style={{
                                                fontSize: "17px",
                                                color: "#4a5568",
                                                marginBottom: index < helplineEntries.length - 1 ? "0px" : "32px",
                                                marginLeft: "40px",
                                                fontWeight: "500",
                                                display: "block",
                                                padding: "8px 16px",
                                                borderRadius: "8px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = "#f7fafc";
                                                e.target.style.color = "#2d3748";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = "transparent";
                                                e.target.style.color = "#4a5568";
                                              }}
                                            >
                                              <span style={{ display: "block" }}>
                                                <strong style={{ color: "#2d3748" }}>
                                                  {entry.name || ""}
                                                </strong>
                                                <a
                                                  href={`tel:${String(entry.mobile || "").replace(/[\s\-\(\)]/g, "")}`}
                                                  style={{
                                                    display: "block",
                                                    color: "#718096",
                                                    textDecoration: "none",
                                                    fontWeight: "500",
                                                    cursor: "pointer",
                                                    marginTop: "4px",
                                                  }}
                                                  onClick={(e) => e.stopPropagation()}
                                                >
                                                  {entry.mobile || ""}
                                                </a>
                                              </span>
                                            </p>
                                          ))}
                                        </>
                                      ) : (
                                        <p
                                          className="auction-helpline-animated hover-lift"
                                          style={{
                                            fontSize: "17px",
                                            color: "#4a5568",
                                            marginBottom: "32px",
                                            fontWeight: "500",
                                            display: "block",
                                            padding: "8px 16px",
                                            borderRadius: "8px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = "#f7fafc";
                                            e.target.style.color = "#2d3748";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = "transparent";
                                            e.target.style.color = "#4a5568";
                                          }}
                                        >
                                          <span style={{ display: isTabletOrMobile ? "block" : "inline" }}>
                                            <span className="icon-bounce" style={{ marginRight: "8px" }}>📞</span>
                                            Need Help :
                                          </span>{" "}
                                          <span style={{ display: "block", marginLeft: isTabletOrMobile ? "0" : "0" }}>
                                            <strong style={{ color: "#2d3748" }}>
                                              {paymentData && paymentData.helpline_name && paymentData.helpline_name.trim() !== ""
                                                ? paymentData.helpline_name
                                                : helpline && helpline.cperson}
                                            </strong>
                                            <a
                                              href={`tel:${String(paymentData && paymentData.helpline_mob && paymentData.helpline_mob.trim() !== ""
                                                ? paymentData.helpline_mob
                                                : (helpline && helpline.mobno) || "").replace(/[\s\-\(\)]/g, "")}`}
                                              style={{
                                                display: "block",
                                                color: "#718096",
                                                textDecoration: "none",
                                                fontWeight: "500",
                                                cursor: "pointer",
                                                marginTop: "4px",
                                              }}
                                              onClick={(e) => e.stopPropagation()}
                                            >
                                              {paymentData && paymentData.helpline_mob && paymentData.helpline_mob.trim() !== ""
                                                ? paymentData.helpline_mob
                                                : helpline && helpline.mobno}
                                            </a>
                                          </span>
                                        </p>
                                      )}
                                    </div>
                                  )}

                                  {/* Register Button */}
                                  <div className="register-button-section auction-button-animated" style={{ marginTop: "25px" }}>
                                    <button
                                      onClick={() => setShowForm(true)}
                                      style={{
                                        backgroundColor: "#186cc2",
                                        color: "white",
                                        border: "none",
                                        padding: "16px 48px",
                                        fontSize: "20px",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        boxShadow: "0 4px 12px rgba(24, 108, 194, 0.3)",
                                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                        fontWeight: "600",
                                        letterSpacing: "0.3px",
                                        position: "relative",
                                        overflow: "hidden",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = "#155a9e";
                                        e.target.style.transform = "translateY(-3px) scale(1.02)";
                                        e.target.style.boxShadow = "0 8px 20px rgba(24, 108, 194, 0.5)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = "#186cc2";
                                        e.target.style.transform = "translateY(0) scale(1)";
                                        e.target.style.boxShadow = "0 4px 12px rgba(24, 108, 194, 0.3)";
                                      }}
                                      onMouseDown={(e) => {
                                        e.target.style.transform = "translateY(-1px) scale(0.98)";
                                      }}
                                      onMouseUp={(e) => {
                                        e.target.style.transform = "translateY(-3px) scale(1.02)";
                                      }}
                                    >
                                      Register Now
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Form View */}
                  {showForm && (
                    <>
                      <div
                        className="row joinheader"
                        style={{
                          backgroundColor: "rgb(248 248 251)",
                          margin: "20px 0px",
                          padding: "25px 6px",
                          borderRadius: "2px",
                        }}
                      >
                        <div className="item vertical">
                          <div className="info join-auction-form">
                            <div className="col-md-6 join-auction-info">
                              {data ? (
                                <div className="row onlyflex joinauc-flex">
                                  <div className="col-md-2 join-auction-padding">
                                    <Image
                                      src={
                                        data && data.alogo != null
                                          ? path + data.alogo
                                          : auctiondefaultLogo
                                      }
                                      onError={(e) => {
                                        e.target.onerror = null; // Prevent infinite loop
                                        e.target.src = auctiondefaultLogo;
                                      }}
                                      fallback={
                                        <Shimmer width={50} height={50} />
                                      }
                                    />
                                  </div>
                                  <div className="col-md-10">
                                    <h5 className="joinauc-heading">
                                      {data.auctionname}{" "}
                                    </h5>
                                    {localStorage.getItem("auction_id") !==
                                      "51199" &&
                                      localStorage.getItem("auction_id") !==
                                      "56396" &&
                                      date !== "1" && (
                                        <p className="joinauc-date">
                                          Auction on : {data.dt}
                                        </p>
                                      )}

                                    {localStorage.getItem("auction_id") !== "58500" && (
                                      <>
                                        {/* Display helpline entries from JSON array */}
                                        {helplineEntries && helplineEntries.length > 0 ? (
                                          helplineEntries.map((entry, index) => (
                                            <p key={index} className="helpline">
                                              Helpline No. : {entry.mobile || ""} ({entry.name || ""})
                                            </p>
                                          ))
                                        ) : (
                                          <p className="helpline">
                                            Helpline No. :{" "}
                                            {paymentData &&
                                              paymentData.helpline_mob &&
                                              paymentData.helpline_mob.trim() !== ""
                                              ? paymentData.helpline_mob
                                              : helpline && helpline.mobno}{" "}
                                            ({" "}
                                            {paymentData &&
                                              paymentData.helpline_name &&
                                              paymentData.helpline_name.trim() !== ""
                                              ? paymentData.helpline_name
                                              : helpline && helpline.cperson}{" "}
                                            )
                                          </p>
                                        )}
                                      </>
                                    )}
                                    {/* Registration Fee - Mobile View */}
                                    {/* {pyqr && pyqr.fee && String(pyqr.fee).trim() !== "" && (
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          color: "#666",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        Registration Fee: ₹{pyqr.fee}
                                      </p>
                                    )} */}
                                    {data.info && (
                                      <div
                                        className="info-box"
                                        dangerouslySetInnerHTML={{ __html: data.info }}
                                      ></div>
                                    )}

                                    {localStorage.getItem("auction_id") ==
                                      38332 && (
                                        <p>Tournament dates : Feb 2nd 2025</p>
                                      )}
                                    {localStorage.getItem("auction_id") ==
                                      38332 && (
                                        <p>
                                          Ground : Skyline University, Sharjah
                                        </p>
                                      )}
                                    {localStorage.getItem("auction_id") ==
                                      38332 && (
                                        <p>
                                          Helpline No. : +97 1554880193, +97
                                          1527741732, +97 1555848783
                                        </p>
                                      )}

                                    {localStorage.getItem("auction_id") ==
                                      39141 && (
                                        <p style={{ lineHeight: "17px" }}>
                                          {" "}
                                          <b> Tournament Date</b> : 11-02-2025 ,
                                          Tuesday Morning
                                        </p>
                                      )}
                                    {localStorage.getItem("auction_id") ==
                                      39141 && (
                                        <p style={{ lineHeight: "17px" }}>
                                          {" "}
                                          <b> Important note</b> : Please make
                                          sure that you will be available for the
                                          tournament once you have registered. The
                                          selected players who are not playing in
                                          the tournament without valid reason will
                                          be banned from upcoming
                                          auction tournaments.
                                        </p>
                                      )}
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                            {/* {isjoinanother && <div className="col-md-6 join-auction-info-form">
                          <div className="row">
                            <form
                              onSubmit={handleSubmitCode(auctionCodeSubmit)}
                              action=""
                              autoComplete="off"
                              encType="multipart/form-data"
                            >
                              <div className="col-md-4">
                                <div className="form-group">
                                  <input
                                    className="form-control"
                                    type="text"
                                    maxLength={9}
                                    minLength={8}
                                    placeholder="Enter A-Code"
                                    {...registerCode("acode", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errorsCode.acode && (
                                    <p className="text-error">
                                      {errorsCode.acode.message}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-8 join-auction-padding">
                                <div className="form-group">
                                  <button className="button" type="submit">
                                    {" "}
                                    SUBMIT
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>} */}
                            {/* {!isjoinanother && <button onClick={() => setisjoinanother(!isjoinanother)} className="joinanotherbtn">Join Another</button>} */}
                          </div>
                        </div>
                        {!isregon && (
                          <div style={{ fontSize: "2rem", fontWeight: "bold" }}>
                            Registration Closed !
                          </div>
                        )}
                      </div>
                      {isregon && (
                        <div className="row reg-form-fields">
                          <div className="reg-items" style={{ width: "100%" }}>
                            <div className="col-md-12 reg-form full-width-form">
                              <form
                                onSubmit={handleSubmit(onSubmit)}
                                action=""
                                autoComplete="off"
                                encType="multipart/form-data"
                              >
                                <div className="row">
                                  <div className="col-md-12 no-side-padd fields-section">
                                    <input
                                      {...register("acode")}
                                      type="hidden"
                                      defaultValue={localStorage.getItem(
                                        "acode"
                                      )}
                                    />
                                    <div className="row">
                                      <div className="col-md-6 no-side-padd">
                                        <div className="form-group text-box-margin joinauc-margintop">
                                          <div className="col-md-4 margin-top-14px joinauc-profpic no-side-padd">
                                            <label
                                              htmlFor="crop-pic"
                                              className="joinauc-label"
                                            >
                                              {" "}
                                              Profile Pic*{/*logo*/}{" "}
                                            </label>
                                          </div>
                                          <div className="col-md-8 margin-top-14px joinauc-margtop no-side-padd">
                                            {/* <Demo /> */}
                                            {localStorage.getItem("crp_typ") ==
                                              0 ? (
                                              <ImageCropper2
                                                croppedImage={croppedImage}
                                                defaultImage={defimg}
                                                setCroppedImage={
                                                  setCroppedImage
                                                }
                                              />
                                            ) : (
                                              <ImageCropper1
                                                croppedImage={croppedImage}
                                                defaultimage={defimg}
                                                setCroppedImage={
                                                  setCroppedImage
                                                }
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-6 no-side-padd">
                                        {/* {!loginuser && */}
                                        <div className="row padd15">
                                          <div className="col-md-4 no-side-padd">
                                            <div className="form-group text-box-margin nobottommar ">
                                              {localStorage.getItem(
                                                "auction_id"
                                              ) == 54790 ? (
                                                <label className="joinauc-label">
                                                  Full Name*
                                                </label>
                                              ) : localStorage.getItem(
                                                "auction_id"
                                              ) == 62149 ? (
                                                <label className="joinauc-label">
                                                  Full Name*
                                                </label>
                                              ) : (
                                                <label className="joinauc-label">
                                                  Name*
                                                </label>
                                              )}
                                            </div>
                                          </div>
                                          <div className="col-md-8 no-side-padd">
                                            <div className="form-group text-box-margin joinauction-margb">
                                              <input
                                                className="form-control joinaucinput-control"
                                                type="text"
                                                id="pname"
                                                {...register("pname", {
                                                  required: "This is required",
                                                })}
                                              />
                                              {errors.pname && (
                                                <p className="text-error">
                                                  {errors.pname.message}
                                                </p>
                                              )}
                                            </div>
                                          </div>
                                        </div>

                                        {data && data.show.mobile.show == 1 && (
                                          <div className="row padd15">
                                            <div className="col-md-4 no-side-padd">
                                              <div className="form-group text-box-margin nobottommar">
                                                {/* <label>{data.show.mobile.label !== "" ? data.show.mobile.label.charAt(0).toUpperCase() + data.show.mobile.label.slice(1) : "Mobile No."}{data.show.mobile.req == '1' && '*'}</label> */}
                                                {localStorage.getItem(
                                                  "auction_id"
                                                ) == 38332 ? (
                                                  <label
                                                    htmlFor=""
                                                    className="joinauc-label"
                                                  >
                                                    WhatsApp Number*
                                                  </label>
                                                ) : data.show.mobile.label !==
                                                  "" ? (
                                                  <label
                                                    htmlFor=""
                                                    className="joinauc-label"
                                                  >
                                                    {data.show.mobile.label}*
                                                  </label>
                                                ) : (
                                                  <label
                                                    htmlFor=""
                                                    className="joinauc-label"
                                                  >
                                                    Mobile No.*
                                                  </label>
                                                )}
                                              </div>
                                            </div>
                                            <div className="col-md-8 no-side-padd">
                                              <div className="form-group text-box-margin joinauction-margb">
                                                <input
                                                  className="form-control joinaucinput-control"
                                                  type="number"
                                                  id="mobno"
                                                  placeholder={
                                                    localStorage.getItem(
                                                      "auction_id"
                                                    ) == "54901"
                                                      ? "Ex: 0523456782"
                                                      : data.show.mobile
                                                        .pholder || undefined
                                                  }
                                                  {...register("mobno", {
                                                    required:
                                                      "This is required",
                                                    ...(localStorage.getItem(
                                                      "auction_id"
                                                    ) == "54901"
                                                      ? {
                                                        minLength: {
                                                          value: 10,
                                                          message:
                                                            "Mobile number must be exactly 10 digits",
                                                        },
                                                        maxLength: {
                                                          value: 10,
                                                          message:
                                                            "Mobile number must be exactly 10 digits",
                                                        },
                                                        validate: (value) =>
                                                          value.length ===
                                                          10 ||
                                                          "Mobile number must be exactly 10 digits",
                                                      }
                                                      : {}),
                                                  })}
                                                  // For 54901, restrict input to 10 digits
                                                  maxLength={
                                                    localStorage.getItem(
                                                      "auction_id"
                                                    ) == "54901"
                                                      ? 10
                                                      : undefined
                                                  }
                                                  minLength={
                                                    localStorage.getItem(
                                                      "auction_id"
                                                    ) == "54901"
                                                      ? 10
                                                      : undefined
                                                  }
                                                  onInput={(e) => {
                                                    if (
                                                      localStorage.getItem(
                                                        "auction_id"
                                                      ) == "54901"
                                                    ) {
                                                      e.target.value =
                                                        e.target.value.slice(
                                                          0,
                                                          10
                                                        );
                                                    }
                                                  }}
                                                />
                                                {errors.mobno && (
                                                  <p className="text-error">
                                                    {errors.mobno.message}
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                        {/* } */}
                                        {data && data.show.age.show == 1 && (
                                          <div className="row padd15">
                                            <div className="col-md-4 no-side-padd">
                                              <div className="form-group text-box-margin nobottommar">
                                                <label className="joinauc-label">
                                                  {" "}
                                                  {data?.show.age.label !== ""
                                                    ? data?.show.age.label
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    data?.show.age.label.slice(
                                                      1
                                                    )
                                                    : "Age"}
                                                  {data?.show.age.req == "1" &&
                                                    "*"}
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-md-8 no-side-padd">
                                              <div className="form-group text-box-margin joinauction-margb">
                                                <input
                                                  className="form-control joinaucinput-control"
                                                  type="number"
                                                  id="age"
                                                  {...register("age", {
                                                    required:
                                                      data?.show.age.req == 1
                                                        ? "This is required"
                                                        : false,
                                                  })}
                                                />
                                                {errors.age && (
                                                  <p className="text-error">
                                                    {errors.age.message}
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        {data && data.show.fname.show == 1 && (
                                          <div className="row padd15">
                                            <div className="col-md-4 no-side-padd">
                                              <div className="form-group text-box-margin nobottommar">
                                                <label className="joinauc-label">
                                                  {data.show.fname.label !== ""
                                                    ? data.show.fname.label
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    data.show.fname.label.slice(
                                                      1
                                                    )
                                                    : "Father's name"}
                                                  {data.show.fname.req == "1" &&
                                                    "*"}
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-md-8 no-side-padd">
                                              <div className="form-group text-box-margin joinauction-margb">
                                                <input
                                                  className="form-control joinaucinput-control"
                                                  type="text"
                                                  id="fname"
                                                  placeholder={
                                                    data.show.fname.pholder ||
                                                    "Father's Name"
                                                  }
                                                  {...register("fname", {
                                                    required:
                                                      data.show.fname.req == 1
                                                        ? "This is required"
                                                        : false,
                                                  })}
                                                />
                                                {errors.fname && (
                                                  <p className="text-error">
                                                    {errors.fname.message}
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    {data && data.show.tname.show == 1 && (
                                      <div className="col-md-6 no-side-padd">
                                        <div className="form-group text-box-margin joinauction-margb">
                                          <label
                                            htmlFor="tshirt"
                                            className="joinauc-label"
                                          >
                                            {" "}
                                            {data.show.tname.label !== ""
                                              ? data.show.tname.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.tname.label.slice(1)
                                              : "Jersey Name"}
                                            {data.show.tname.req == "1" && "*"}
                                          </label>
                                          <input
                                            placeholder={
                                              data.show.tname.pholder ||
                                              "Jersey Name"
                                            }
                                            className="form-control joinaucinput-control"
                                            type="text"
                                            {...register("jrnm", {
                                              required:
                                                data.show.tname.req == 1
                                                  ? "This is required"
                                                  : false,
                                            })}
                                          />
                                          {errors.jrnm && (
                                            <p className="text-error">
                                              {errors.jrnm.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {data && data.show.tno.show == 1 && (
                                      <div className="col-md-6 no-side-padd">
                                        <div className="form-group text-box-margin joinauction-margb">
                                          <label
                                            htmlFor="tshirt"
                                            className="joinauc-label"
                                          >
                                            {" "}
                                            {data.show.tno.label !== ""
                                              ? data.show.tno.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.tno.label.slice(1)
                                              : "Jersey Number"}
                                            {data.show.tno.req == "1" && "*"}
                                          </label>
                                          <input
                                            placeholder={
                                              data.show.tno.pholder ||
                                              "Jersey Number"
                                            }
                                            className="form-control joinaucinput-control"
                                            type="number"
                                            onKeyPress={(e) => {
                                              if (localStorage.getItem("auction_id") === "60744") {
                                                if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab") {
                                                  e.preventDefault();
                                                }
                                              }
                                            }}
                                            onInput={(e) => {
                                              if (localStorage.getItem("auction_id") === "60744") {
                                                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                              }
                                            }}
                                            {...register("jrno", {
                                              required:
                                                data.show.tno.req == 1
                                                  ? "This is required"
                                                  : false,
                                            })}
                                          />
                                          {errors.jrno && (
                                            <p className="text-error">
                                              {errors.jrno.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {data && data.show.tshirt.show == 1 && (
                                      <div className="col-md-6 no-side-padd">
                                        <div className="form-group text-box-margin joinauction-margb">
                                          <label
                                            htmlFor="tshirt"
                                            className="joinauc-label"
                                          >
                                            {" "}
                                            {data.show.tshirt.label !== ""
                                              ? data.show.tshirt.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.tshirt.label.slice(1)
                                              : "T-Shirt Size"}
                                            {data.show.tshirt.req == "1" && "*"}
                                          </label>
                                          <input
                                            className="form-control joinaucinput-control"
                                            type="text"
                                            placeholder={
                                              data.show.tshirt.pholder ||
                                              (localStorage.getItem("aid") ==
                                                37866
                                                ? "28/30/32/34/36/38/40"
                                                : "S/M/L/XL/XXL/XXXL")
                                            }
                                            id="tshirt"
                                            {...register("tshirt", {
                                              required:
                                                data.show.tshirt.req == 1
                                                  ? "This is required"
                                                  : false,
                                            })}
                                          />

                                          {errors.tshirt && (
                                            <p className="text-error">
                                              {errors.tshirt.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {data && data.show.trouser.show == 1 && (
                                      <div className="col-md-6 no-side-padd">
                                        <div className="form-group text-box-margin joinauction-margb">
                                          <label
                                            htmlFor="trouser"
                                            className="joinauc-label"
                                          >
                                            {" "}
                                            {data.show.trouser.label !== ""
                                              ? data.show.trouser.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.trouser.label.slice(1)
                                              : "Trouser"}
                                            {data.show.trouser.req == "1" &&
                                              "*"}
                                          </label>
                                          <input
                                            className="form-control joinaucinput-control"
                                            id="trouser"
                                            placeholder={
                                              data.show.trouser.pholder ||
                                              "S/M/L/XL/XXL/XXXL"
                                            }
                                            type="text"
                                            {...register("trouser", {
                                              required:
                                                data.show.trouser.req == 1
                                                  ? "This is required"
                                                  : false,
                                            })}
                                          ></input>
                                          {errors.trouser && (
                                            <p className="text-error">
                                              {errors.trouser.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {data &&
                                      data.extra.length > 0 &&
                                      data.extra.map((item, index) => {
                                        if (item.o) {
                                          var dynamicoptions =
                                            item.o.split(",");
                                        }
                                        // // console.log("item is.........");
                                        // // console.log(item);
                                        if (item.s == 0) return;
                                        return (
                                          <div className="col-md-6 no-side-padd">
                                            <div className="form-group text-box-margin">
                                              {item.t != "3" && (
                                                <label htmlFor="tshirt">
                                                  {" "}
                                                  {item.l}
                                                  {item.r == "1" && "*"}
                                                </label>
                                              )}

                                              {item.t == "0" ? (
                                                <input
                                                  placeholder={item.p || item.l}
                                                  className="form-control"
                                                  type="text"
                                                  {...register(
                                                    "extra_" + index,
                                                    {
                                                      required:
                                                        item.r == 1
                                                          ? "This is required"
                                                          : false,
                                                    }
                                                  )}
                                                />
                                              ) : item.t == "1" ? (
                                                <input
                                                  placeholder={item.p || item.l}
                                                  className="form-control"
                                                  type="number"
                                                  {...register(
                                                    "extra_" + index,
                                                    {
                                                      required:
                                                        item.r == 1
                                                          ? "This is required"
                                                          : false,
                                                    }
                                                  )}
                                                />
                                              ) : item.t == "2" ? (
                                                <select
                                                  className="form-control"
                                                  id={item.label}
                                                  type="text"
                                                  {...register(
                                                    "extra_" + index,
                                                    {
                                                      required:
                                                        item.r == 1
                                                          ? "This is required"
                                                          : false,
                                                    }
                                                  )}
                                                >
                                                  <option value="">
                                                    --select--
                                                  </option>
                                                  {dynamicoptions?.map(
                                                    (el, ind) => {
                                                      return (
                                                        <option value={el}>
                                                          {el}
                                                        </option>
                                                      );
                                                    }
                                                  )}
                                                </select>
                                              ) : item.t == "3" ? (
                                                // MULTI CHECKBOX
                                                <div className="checkbox-multi-container">
                                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    {item.l}
                                                    {item.r == 1 && <span className="text-red-500">*</span>}
                                                  </label>

                                                  <div className="checkbox-options-wrapper space-y-2">
                                                    {dynamicoptions && dynamicoptions.length > 0 ? (
                                                      dynamicoptions.map((opt, optIndex) => (
                                                        <label
                                                          key={optIndex}
                                                          style={{
                                                            gap: "10px",
                                                            alignItems: 'center',
                                                            height: "20px"
                                                          }}
                                                          className="flex items-center space-x-2 cursor-pointer"
                                                        >
                                                          <input
                                                            type="checkbox"
                                                            value={opt}
                                                            {...register(`extra_${index}`, {
                                                              required:
                                                                item.r == 1
                                                                  ? "Please select at least one option"
                                                                  : false,
                                                            })}
                                                            className="h-4 w-4"
                                                          />
                                                          <span className="text-sm text-gray-700">{opt}</span>
                                                        </label>
                                                      ))
                                                    ) : (
                                                      <p className="text-xs text-gray-500">No options configured</p>
                                                    )}
                                                  </div>

                                                  {errors?.[`extra_${index}`] && (
                                                    <p className="error-text text-red-500 text-xs mt-1 w-full">
                                                      {errors[`extra_${index}`].message}
                                                    </p>
                                                  )}
                                                </div>
                                              ) : item.t == "4" ? (
                                                <div className="file-input-container joinaucinput-control">

                                                  <input
                                                    type="file"
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    className="form-control addinput-control"
                                                    onChange={(e) => handleFileUpload(e, index)}
                                                  />

                                                  {/* Error */}
                                                  {errors?.[`extra_${index}`] && (
                                                    <p className="error-text text-red-500 text-xs mt-1">
                                                      {errors[`extra_${index}`].message}
                                                    </p>
                                                  )}

                                                  <p className="text-xs text-gray-500 mt-1">
                                                    Accepted: PDF, JPG, PNG (Max 5MB)
                                                  </p>
                                                </div>
                                              )
                                                : item.t == "5" ? (
                                                  <div className="form-group text-box-margin">
                                                    {/* <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    {item.l}
                                                    {item.r == "1" && (
                                                      <span className="text-red-500">
                                                        *
                                                      </span>
                                                    )}
                                                  </label> */}

                                                    <input
                                                      type="date"
                                                      // min={moment().format(
                                                      //   "YYYY-MM-DD"
                                                      // )}
                                                      className="form-control addinput-control"
                                                      placeholder={
                                                        item.p || "Select date"
                                                      }
                                                      {...register(
                                                        `extra_${index}`,
                                                        {
                                                          required:
                                                            item.r == "1"
                                                              ? "This field is required"
                                                              : false,
                                                        }
                                                      )}
                                                    />

                                                    {errors?.[
                                                      `extra_${index}`
                                                    ] && (
                                                        <p className="text-error text-red-500 text-xs mt-1">
                                                          {
                                                            errors[`extra_${index}`]
                                                              .message
                                                          }
                                                        </p>
                                                      )}
                                                  </div>
                                                ) : null}
                                              {errors.trouser && (
                                                <p className="text-error">
                                                  {errors.trouser.message}
                                                </p>
                                              )}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    {data &&
                                      data.show.cat.show == 1 &&
                                      catData.length > 0 && (
                                        <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner no-side-padd">
                                          <label
                                            htmlFor="spcf1"
                                            className="joinauc-label"
                                          >
                                            {" "}
                                            {data.show.cat.label !== ""
                                              ? data.show.cat.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.cat.label.slice(1)
                                              : "Category"}{" "}
                                            {data.show.cat.req == "1" && "*"}{" "}
                                          </label>
                                          <select
                                            className="form-control spec-control"
                                            type="text"
                                            {...register("catid", {
                                              required:
                                                data.show.cat.req == 1
                                                  ? "This is required"
                                                  : false,
                                            })}
                                            value={catid}
                                            onChange={(e) => {
                                              setcatid(e.target.value);
                                            }}
                                          >
                                            <option value="" selected>
                                              Select{" "}
                                              {data.show.cat.label !== ""
                                                ? data.show.cat.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                data.show.cat.label.slice(1)
                                                : "Category"}
                                            </option>
                                            {catData?.map((ct) => (
                                              <option
                                                value={ct.cid}
                                                key={ct.cid}
                                              >
                                                {ct.cname}
                                              </option>
                                            ))}
                                          </select>
                                          {errors.catid && (
                                            <p className="text-error">
                                              {errors.catid.message}
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    {data &&
                                      data.show.icon.show == 1 &&
                                      auctype == "0" &&
                                      localStorage.getItem("auction_id") == "59799" && (
                                        <div className="col-md-12 martop joinauc-margtop no-side-padd">
                                          <div className="row">
                                            <div className="col-md-2 margin-top-14px joinauc-margtop no-side-padd">
                                              <label
                                                htmlFor=""
                                                className="joinauc-label"
                                              >
                                                {" "}
                                                {data.show.icon.label !== ""
                                                  ? data.show.icon.label
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  data.show.icon.label.slice(
                                                    1
                                                  )
                                                  : "Playing style"}
                                                {data.show.icon.req == "1" &&
                                                  "*"}
                                              </label>
                                            </div>
                                            <div className="col-md-8 no-side-padd">
                                              <div
                                                className={`roleclass form-group text-box-margin joinauction-margb ${isTabletOrMobile || isPortrait
                                                  ? "row"
                                                  : null
                                                  }`}
                                              >
                                                <div className="">
                                                  <img
                                                    onClick={() =>
                                                      setisbat(!isbat)
                                                    }
                                                    src={bat}
                                                    alt=""
                                                    style={batstyle}
                                                  />
                                                </div>
                                                <div className="">
                                                  <img
                                                    onClick={() =>
                                                      setisbol(!isbol)
                                                    }
                                                    src={ball}
                                                    alt=""
                                                    style={bolstyle}
                                                  />
                                                </div>
                                                <div className="">
                                                  <img
                                                    onClick={() =>
                                                      setiswkeep(!iswkeep)
                                                    }
                                                    src={wkeeper}
                                                    alt=""
                                                    style={wkeepstyle}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                    <div className="col-md-12 margin-top-14px joinauc-margtop no-side-padd">
                                      <div className="row">
                                        <div className="col-md-6 no-side-padd no-side-padd-lap">
                                          {data && data.show.sp1.show == 1 && (
                                            <div className="row">
                                              <div className="form-group text-box-margin joinauction-margb">
                                                <div className="col-md-4 no-side-padd no-side-padd-lap">
                                                  <label
                                                    htmlFor="spcf1"
                                                    className="joinauc-label"
                                                  >
                                                    {" "}
                                                    {data.show.sp1.label !== ""
                                                      ? data.show.sp1.label
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      data.show.sp1.label.slice(
                                                        1
                                                      )
                                                      : "Specification 1"}
                                                    {data.show.sp1.req == "1" &&
                                                      "*"}{" "}
                                                  </label>
                                                </div>
                                                {auctype != 0 ? (
                                                  <div className="col-md-8 no-side-padd">
                                                    {" "}
                                                    <input
                                                      placeholder={
                                                        data.show.sp1.pholder ||
                                                        "Specification 1"
                                                      }
                                                      className="form-control spec-control"
                                                      type="text"
                                                      {...register("spcf1", {})}
                                                    />
                                                  </div>
                                                ) : data.show.sp1.opt == "" ||
                                                  data.show.sp1.opt == null ? (
                                                  <div className="col-md-6 no-side-padd no-side-padd-lap">
                                                    {/* jjjjjj */}

                                                    <select
                                                      className="form-control spec-control"
                                                      id="spcf1"
                                                      type="text"
                                                      {...register("spcf1", {
                                                        required:
                                                          data.show.sp1.req == 1
                                                            ? "This is required"
                                                            : false,
                                                      })}
                                                      onChange={(e) => {
                                                        if (
                                                          e.target.value ===
                                                          "Other"
                                                        ) {
                                                          setOtherBatting(true);
                                                        } else {
                                                          setOtherBatting(
                                                            false
                                                          );
                                                        }
                                                        setBatting(
                                                          e.target.value
                                                        );
                                                      }}
                                                    >
                                                      <option value={""}>
                                                        --select--
                                                      </option>
                                                      {sp1opt.map((ele) => (
                                                        <option value={ele}>
                                                          {ele}
                                                        </option>
                                                      ))}
                                                    </select>
                                                    {errors.spcf1 && (
                                                      <p className="text-error">
                                                        {errors.spcf1.message}
                                                      </p>
                                                    )}
                                                  </div>
                                                ) : (
                                                  <div className="col-md-6 no-side-padd no-side-padd-lap">
                                                    {/* kkkkk */}
                                                    <select
                                                      className="form-control"
                                                      id="spcf1"
                                                      type="text"
                                                      {...register("spcf1", {
                                                        required:
                                                          data.show.sp1.req == 1
                                                            ? "This is required"
                                                            : false,
                                                      })}
                                                      onChange={(e) => {
                                                        if (
                                                          e.target.value ===
                                                          "Other"
                                                        ) {
                                                          setOtherBatting(true);
                                                        } else {
                                                          setOtherBatting(
                                                            false
                                                          );
                                                        }
                                                        setBatting(
                                                          e.target.value
                                                        );
                                                      }}
                                                    >
                                                      <option value={""}>
                                                        --select--
                                                      </option>
                                                      {data?.show?.sp1?.opt
                                                        ?.split(",")
                                                        .map((ele) => (
                                                          <option value={ele}>
                                                            {ele}
                                                          </option>
                                                        ))}
                                                    </select>
                                                    {errors.spcf1 && (
                                                      <p className="text-error">
                                                        {errors.spcf1.message}
                                                      </p>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                        {otherBatting ? (
                                          <div className="col-md-6 no-side-padd ">
                                            <div className="row form-group text-box-margin">
                                              <div className="col-md-4 no-side-padd ">
                                                <label htmlFor="spcf2">
                                                  {" "}
                                                  Other{" "}
                                                </label>
                                              </div>
                                              <div className="col-md-8 no-side-padd">
                                                <input
                                                  placeholder="Other"
                                                  className="form-control"
                                                  type="text"
                                                  {...register("spcf1_other")}
                                                  onChange={(e) =>
                                                    setBatting(e.target.value)
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-md-12 margin-top-14px joinauc-margtop no-side-padd">
                                      {data && data.show.sp2.show == 1 && (
                                        <div className="row">
                                          <div className="col-md-6 no-side-padd no-side-padd-lap">
                                            <div className="row">
                                              <div className="form-group text-box-margin joinauction-margb">
                                                <div className="col-md-4 no-side-padd no-side-padd-lap">
                                                  <label
                                                    htmlFor="spcf2"
                                                    className="joinauc-label"
                                                  >
                                                    {" "}
                                                    {data.show.sp2.label !== ""
                                                      ? data.show.sp2.label
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      data.show.sp2.label.slice(
                                                        1
                                                      )
                                                      : "Specification 2"}
                                                    {data.show.sp2.req == "1" &&
                                                      "*"}{" "}
                                                  </label>
                                                </div>
                                                {auctype != 0 ? (
                                                  <div className="col-md-8 no-side-padd">
                                                    {" "}
                                                    <input
                                                      placeholder={
                                                        data.show.sp2.pholder ||
                                                        "Specification 2"
                                                      }
                                                      className="form-control spec-control"
                                                      type="text"
                                                      {...register("spcf2", {})}
                                                    />
                                                  </div>
                                                ) : data.show.sp2.opt == "" ||
                                                  data.show.sp2.opt == null ? (
                                                  <div className="col-md-6 no-side-padd no-side-padd-lap">
                                                    {" "}
                                                    <select
                                                      className="form-control spec-control"
                                                      id="spcf2"
                                                      type="text"
                                                      {...register("spcf2", {
                                                        required:
                                                          data.show.sp2.req == 1
                                                            ? "This is required"
                                                            : false,
                                                      })}
                                                      onChange={(e) => {
                                                        if (
                                                          e.target.value ===
                                                          "Other"
                                                        ) {
                                                          setOtherBowling(true);
                                                        } else {
                                                          setOtherBowling(
                                                            false
                                                          );
                                                        }
                                                        setBowling(
                                                          e.target.value
                                                        );
                                                      }}
                                                    >
                                                      <option value={""}>
                                                        --select--
                                                      </option>
                                                      {localStorage.getItem("auction_id") === "62390" &&
                                                      batting === "All Rounder"
                                                        ? [...sp2opt, ...sp3opt].map((ele) => (
                                                          <option value={ele}>
                                                            {ele}
                                                          </option>
                                                        ))
                                                        : batting ==
                                                        "Bowling All Rounder" ||
                                                        batting == "Bowler"
                                                        ? sp3opt.map((ele) => (
                                                          <option value={ele}>
                                                            {ele}
                                                          </option>
                                                        ))
                                                        : sp2opt.map((ele) => (
                                                          <option value={ele}>
                                                            {ele}
                                                          </option>
                                                        ))}
                                                      {/* <option value="Other">
                                                        Other
                                                      </option> */}
                                                    </select>
                                                    {errors.spcf2 && (
                                                      <p className="text-error">
                                                        {errors.spcf2.message}
                                                      </p>
                                                    )}
                                                  </div>
                                                ) : (
                                                  <div className="col-md-6 no-side-padd no-side-padd-lap">
                                                    {" "}
                                                    <select
                                                      className="form-control"
                                                      id="spcf2"
                                                      type="text"
                                                      {...register("spcf2", {
                                                        required:
                                                          data.show.sp2.req == 1
                                                            ? "This is required"
                                                            : false,
                                                      })}
                                                      onChange={(e) => {
                                                        if (
                                                          e.target.value ===
                                                          "Other"
                                                        ) {
                                                          setOtherBowling(true);
                                                        } else {
                                                          setOtherBowling(
                                                            false
                                                          );
                                                        }
                                                        setBowling(
                                                          e.target.value
                                                        );
                                                      }}
                                                    >
                                                      <option value={""}>
                                                        --select--
                                                      </option>
                                                      {localStorage.getItem("auction_id") === "62390" &&
                                                      batting === "All Rounder"
                                                        ? [
                                                            ...(data?.show?.sp2?.opt
                                                              ? data.show.sp2.opt.split(",")
                                                              : sp2opt),
                                                            ...(data?.show?.sp3?.opt
                                                              ? data.show.sp3.opt.split(",")
                                                              : sp3opt),
                                                          ].map((ele) => (
                                                            <option
                                                              value={ele.trim()}
                                                            >
                                                              {ele.trim()}
                                                            </option>
                                                          ))
                                                        : batting ==
                                                          "Bowling All Rounder" ||
                                                          batting == "Bowler"
                                                        ? data?.show?.sp3.opt ==
                                                          ""
                                                          ? sp3opt.map(
                                                            (ele) => (
                                                              <option
                                                                value={ele}
                                                              >
                                                                {ele}
                                                              </option>
                                                            )
                                                          )
                                                          : data?.show?.sp3?.opt
                                                            ?.split(",")
                                                            .map((ele) => (
                                                              <option
                                                                value={ele}
                                                              >
                                                                {ele}
                                                              </option>
                                                            ))
                                                        : data?.show?.sp2
                                                          ?.opt == ""
                                                          ? sp2opt.map((ele) => (
                                                            <option value={ele}>
                                                              {ele}
                                                            </option>
                                                          ))
                                                          : data?.show?.sp2?.opt
                                                            ?.split(",")
                                                            .map((ele) => (
                                                              <option
                                                                value={ele}
                                                              >
                                                                {ele}
                                                              </option>
                                                            ))}
                                                      {/* <option value="Other">
                                                        Other
                                                      </option> */}
                                                    </select>
                                                    {errors.spcf2 && (
                                                      <p className="text-error">
                                                        {errors.spcf2.message}
                                                      </p>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          {otherBowling ? (
                                            <div className="col-md-6 no-side-padd">
                                              <div className="row form-group text-box-margin">
                                                <div className="col-md-4 no-side-padd">
                                                  <label htmlFor="spcf2">
                                                    {" "}
                                                    Other{" "}
                                                  </label>
                                                </div>
                                                <div className="col-md-8 no-side-padd">
                                                  <input
                                                    placeholder="Other"
                                                    className="form-control"
                                                    // {...register("spcf2")}
                                                    type="text"
                                                    {...register("spcf2_other")}
                                                    onChange={(e) =>
                                                      setBowling(e.target.value)
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    {data && data.show.sp3.show == 1 && (
                                      <div className="row">
                                        <div className="col-md-6 margin-top-14px joinauc-margtop no-side-padd no-side-padd-lap">
                                          <div className="form-group text-box-margin joinauction-margb">
                                            <div className="col-md-4 no-side-padd">
                                              <label
                                                htmlFor="spcf1"
                                                className="joinauc-label"
                                              >
                                                {" "}
                                                {data.show.sp3.label !== ""
                                                  ? data.show.sp3.label
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  data.show.sp3.label.slice(1)
                                                  : "Specification 3"}
                                                {data.show.sp3.req == "1" &&
                                                  "*"}{" "}
                                              </label>
                                            </div>
                                            {auctype != 0 ? (
                                              <div className="col-md-8 no-side-padd">
                                                {" "}
                                                <input
                                                  placeholder={
                                                    data.show.sp3.pholder ||
                                                    "Specification 3"
                                                  }
                                                  className="form-control spec-control"
                                                  type="text"
                                                  {...register("spcf3", {})}
                                                />
                                              </div>
                                            ) : data.show.sp3.opt == "" ||
                                              data.show.sp3.opt == null ? (
                                              <div className="col-md-6 no-side-padd">
                                                {" "}
                                                <select
                                                  className="form-control spec-control"
                                                  id="spcf3"
                                                  type="text"
                                                  {...register("spcf3", {
                                                    required: false,
                                                    // required: "required field.",
                                                  })}
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.value === "Other"
                                                    ) {
                                                      setOthersp3(true);
                                                    } else {
                                                      setOthersp3(false);
                                                    }
                                                    setsp3(e.target.value);
                                                  }}
                                                >
                                                  <option value={""}>
                                                    --Specification 3--
                                                  </option>
                                                  {batting ==
                                                    "Bowling All Rounder" ||
                                                    batting == "Bowler"
                                                    ? sp2opt.map((ele) => (
                                                      <option value={ele}>
                                                        {ele}
                                                      </option>
                                                    ))
                                                    : sp3opt.map((ele) => (
                                                      <option value={ele}>
                                                        {ele}
                                                      </option>
                                                    ))}

                                                  {/* <option value="Other">
                                                    Other
                                                  </option> */}
                                                </select>
                                                {errors.spcf2 && (
                                                  <p className="text-error">
                                                    {errors.spcf2.message}
                                                  </p>
                                                )}
                                              </div>
                                            ) : (
                                              <div className="col-md-6 no-side-padd">
                                                {" "}
                                                <select
                                                  className="form-control"
                                                  id="spcf3"
                                                  type="text"
                                                  {...register("spcf3", {
                                                    required: false,
                                                    // required: "required field.",
                                                  })}
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.value === "Other"
                                                    ) {
                                                      setOthersp3(true);
                                                    } else {
                                                      setOthersp3(false);
                                                    }
                                                    setsp3(e.target.value);
                                                  }}
                                                >
                                                  <option value={""}>
                                                    --Specification 3--
                                                  </option>
                                                  {batting ==
                                                    "Bowling All Rounder" ||
                                                    batting == "Bowler"
                                                    ? data?.show?.sp2.opt == ""
                                                      ? sp2opt.map((ele) => (
                                                        <option value={ele}>
                                                          {ele}
                                                        </option>
                                                      ))
                                                      : data?.show?.sp2?.opt
                                                        ?.split(",")
                                                        .map((ele) => (
                                                          <option value={ele}>
                                                            {ele}
                                                          </option>
                                                        ))
                                                    : data?.show?.sp3?.opt == ""
                                                      ? sp3opt.map((ele) => (
                                                        <option value={ele}>
                                                          {ele}
                                                        </option>
                                                      ))
                                                      : data?.show?.sp3?.opt
                                                        ?.split(",")
                                                        .map((ele) => (
                                                          <option value={ele}>
                                                            {ele}
                                                          </option>
                                                        ))}

                                                  {/* <option value="Other">
                                                    Other
                                                  </option> */}
                                                </select>
                                                {errors.spcf2 && (
                                                  <p className="text-error">
                                                    {errors.spcf2.message}
                                                  </p>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        {othersp3 ? (
                                          <div className="col-md-6 no-side-padd">
                                            <div className="row form-group text-box-margin">
                                              <div className="col-md-4 no-side-padd">
                                                <label htmlFor="spcf2">
                                                  {" "}
                                                  Other{" "}
                                                </label>
                                              </div>
                                              <div className="col-md-8 no-side-padd">
                                                <input
                                                  placeholder="Other"
                                                  className="form-control"
                                                  type="text"
                                                  {...register("spcf3_other")}
                                                  onChange={(e) =>
                                                    setsp3(e.target.value)
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                    {localStorage.getItem("auction_id") ==
                                      "58060" && (
                                        <button
                                          onClick={() => {
                                            const paymentUrl =
                                              "https://buy.stripe.com/8x29AS9sI0wscq61Ttg360g";

                                            window.open(
                                              paymentUrl,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                          }}
                                          style={{
                                            backgroundColor: "#0d6efd",
                                            color: "white",
                                            padding: "14px 32px",
                                            fontSize: "18px",
                                            border: "none",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                            fontWeight: "bold",
                                            boxShadow:
                                              "0 4px 12px rgba(13, 110, 253, 0.3)",
                                            transition: "all 0.2s",
                                            marginTop: "2em",
                                            marginBottom: "10px",
                                            marginLeft: "1.2em",
                                          }}
                                          onMouseEnter={(e) =>
                                          (e.target.style.backgroundColor =
                                            "#0b5ed7")
                                          }
                                          onMouseLeave={(e) =>
                                          (e.target.style.backgroundColor =
                                            "#0d6efd")
                                          }
                                        >
                                          Pay Now
                                        </button>
                                      )}
                                    {localStorage.getItem("auction_id") ===
                                      "57247" && (
                                        <div
                                          className="col-md-6 no-side-padd"
                                          style={{ marginTop: "8px" }}
                                        >
                                          <div className="form-group text-box-margin">
                                            <label>
                                              Zeffy Payment Member Number (Top
                                              right corner of the Member ID)*
                                            </label>

                                            <input
                                              placeholder="Zeffy Payment Member Number"
                                              className="form-control"
                                              type="text"
                                              {...register("extra_8", {
                                                required: "This is required",
                                              })}
                                            />

                                            {errors["extra_8"] && (
                                              <p className="text-error">
                                                {errors["extra_8"].message}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      )}

                                    {data && data.show.detail.show == 1 && (
                                      <div className="col-md-12 no-side-padd">
                                        <div className="form-group text-box-margin joinauction-margb">
                                          <label
                                            htmlFor="detail"
                                            className="joinauc-label"
                                          >
                                            {data.show.detail.label !== ""
                                              ? data.show.detail.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.detail.label.slice(1)
                                              : "Detail"}
                                            {data.show.detail.req == "1" && "*"}{" "}
                                          </label>
                                          <textarea
                                            className="form-control joinaucdetail-control"
                                            placeholder={
                                              data.show.detail.pholder ||
                                              "Detail"
                                            }
                                            id="other_details"
                                            {...register("detail", {
                                              required:
                                                data.show.detail.req == 1
                                                  ? "This is required"
                                                  : false,
                                            })}
                                          ></textarea>
                                        </div>
                                      </div>
                                    )}

                                    {paymentData &&
                                      paymentData.show_payment == 1 && (
                                        <div className="col-md-12 no-side-padd">
                                          <div className="form-group text-box-margin">
                                            {/* Debug info - remove in production */}

                                            <QRContainer>
                                              {/* Show QR Image only for UPI payments */}
                                              {paymentData &&
                                                paymentData.payment_method ===
                                                "upi" &&
                                                (pyqr.mob || pyqr.qr) && (
                                                  <QRImageWrapper>
                                                    <QRImage
                                                      src={
                                                        pyqr.qr
                                                          ? `${pyqr.path}${pyqr.qr}`
                                                          : data &&
                                                            data.alogo != null
                                                            ? path + data.alogo
                                                            : auctiondefaultLogo
                                                      }
                                                      alt="Payment QR Code"
                                                    />
                                                  </QRImageWrapper>
                                                )}

                                              <QRDetailsWrapper>
                                                {/* Bank Payment Details */}
                                                {paymentData &&
                                                  paymentData.payment_method ===
                                                  "bank" &&
                                                  paymentData.bankdt && (
                                                    <>
                                                      <QRSectionTitle>
                                                        Please transfer
                                                        Registration fee{" "}
                                                        <span
                                                          style={{
                                                            fontSize: "1.4rem",
                                                            fontWeight: "bold",
                                                            color: "#689F38",
                                                          }}
                                                        >
                                                          {localStorage.getItem(
                                                            "auction_id"
                                                          ) == 56396 ||
                                                            localStorage.getItem(
                                                              "auction_id"
                                                            ) == 56525
                                                            ? `${paymentData.bankdt.fees} AED`
                                                            : `₹${paymentData.bankdt.fees}`}
                                                        </span>{" "}
                                                        to the following account
                                                      </QRSectionTitle>
                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          Bank Name:
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          {
                                                            paymentData.bankdt
                                                              .bank_name
                                                          }
                                                        </QRDetailValue>
                                                      </QRDetailRow>

                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          Account Number:
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          {
                                                            paymentData.bankdt
                                                              .bank_acc
                                                          }
                                                          <div>
                                                            <button
                                                              onClick={() =>
                                                                formlinkcopy10(
                                                                  paymentData
                                                                    .bankdt
                                                                    .bank_acc
                                                                )
                                                              }
                                                              className="copy-btn"
                                                            >
                                                              {iscopied10 ? (
                                                                <Check className="w-3 h-3" />
                                                              ) : (
                                                                <Copy className="w-3 h-3" />
                                                              )}
                                                            </button>
                                                          </div>
                                                        </QRDetailValue>
                                                      </QRDetailRow>

                                                      {localStorage.getItem(
                                                        "auction_id"
                                                      ) == 56396 ||
                                                        (localStorage.getItem(
                                                          "auction_id"
                                                        ) == 56525 && (
                                                            <QRDetailRow>
                                                              <QRDetailLabel>
                                                                Holder name:
                                                              </QRDetailLabel>
                                                              {localStorage.getItem(
                                                                "auction_id"
                                                              ) == 56396
                                                                ? "RAHIM THENGOTH"
                                                                : "Abdusammad Bangala Mahamood"}
                                                              <QRDetailValue>
                                                                {/* RAHIM THENGOTH */}
                                                              </QRDetailValue>
                                                            </QRDetailRow>
                                                          ))}

                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          {localStorage.getItem(
                                                            "auction_id"
                                                          ) == 56396 ||
                                                            localStorage.getItem(
                                                              "auction_id"
                                                            ) == 56525
                                                            ? "IBAN:"
                                                            : "IFSC Code:"}
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          {
                                                            paymentData.bankdt
                                                              .bank_ifsc
                                                          }
                                                          <div>
                                                            <button
                                                              onClick={() =>
                                                                formlinkcopy11(
                                                                  paymentData
                                                                    .bankdt
                                                                    .bank_ifsc
                                                                )
                                                              }
                                                              className="copy-btn"
                                                            >
                                                              {iscopied11 ? (
                                                                <Check className="w-3 h-3" />
                                                              ) : (
                                                                <Copy className="w-3 h-3" />
                                                              )}
                                                            </button>
                                                          </div>
                                                        </QRDetailValue>
                                                      </QRDetailRow>

                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          Registration Fees:
                                                        </QRDetailLabel>
                                                        <QRDetailValue
                                                          style={{
                                                            fontSize: "1.4rem",
                                                            fontWeight: "bold",
                                                            color: "#689F38",
                                                          }}
                                                        >
                                                          {localStorage.getItem(
                                                            "auction_id"
                                                          ) == 56396 ||
                                                            localStorage.getItem(
                                                              "auction_id"
                                                            ) == 56525
                                                            ? `${paymentData.bankdt.fees} AED`
                                                            : `₹${paymentData.bankdt.fees}`}
                                                        </QRDetailValue>
                                                      </QRDetailRow>

                                                      <QRInstructions>
                                                        Please transfer the
                                                        registration fee to the
                                                        above bank account and
                                                        upload the receipt.
                                                      </QRInstructions>
                                                    </>
                                                  )}

                                                {/* UPI Payment Details */}
                                                {paymentData && localStorage.getItem("auction_id") < "59149" &&
                                                  paymentData.payment_method ===
                                                  "upi" &&
                                                  (pyqr.mob || pyqr.qr) && (
                                                    <>
                                                      <QRSectionTitle>
                                                        Payment Details
                                                      </QRSectionTitle>
                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          Name:
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          {pyqr.name}
                                                        </QRDetailValue>
                                                      </QRDetailRow>

                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          UPI No.:
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          {pyqr.mob}
                                                        </QRDetailValue>
                                                      </QRDetailRow>

                                                      {pyqr && pyqr.fee !== null && pyqr.fee !== undefined && pyqr.fee !== "" && String(pyqr.fee).trim() !== "" && String(pyqr.fee).trim() !== "0" && !isNaN(Number(pyqr.fee)) && Number(pyqr.fee) > 0 && (
                                                        <QRDetailRow>
                                                          <QRDetailLabel>
                                                            Fees:
                                                          </QRDetailLabel>
                                                          <QRFeeValue>
                                                            ₹{pyqr.fee}
                                                          </QRFeeValue>
                                                        </QRDetailRow>
                                                      )}

                                                      <QRInstructions>
                                                        Please scan the QR code
                                                        to make the payment and
                                                        upload the receipt.
                                                      </QRInstructions>

                                                      {/* Pay Now Button for UPI Payment - Mobile Only - Only for auction_id 61248 */}
                                                      {/* {isMobileOnly && localStorage.getItem("auction_id") == "56529" && (
                                                        <div style={{ marginTop: "25px", textAlign: "center", padding: "15px" }}>
                                                          <button
                                                            type="button"
                                                            onClick={handlePayNow}
                                                            style={{
                                                              backgroundColor: "#25D366",
                                                              color: "white",
                                                              padding: "16px 40px",
                                                              fontSize: "18px",
                                                              fontWeight: "bold",
                                                              border: "none",
                                                              borderRadius: "12px",
                                                              cursor: "pointer",
                                                              boxShadow: "0 4px 15px rgba(37, 211, 102, 0.4)",
                                                              transition: "all 0.3s ease",
                                                              width: "100%",
                                                              maxWidth: "350px",
                                                              display: "inline-block",
                                                            }}
                                                            onMouseEnter={(e) => {
                                                              e.target.style.backgroundColor = "#20BA5A";
                                                              e.target.style.transform = "scale(1.05)";
                                                              e.target.style.boxShadow = "0 6px 20px rgba(37, 211, 102, 0.5)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                              e.target.style.backgroundColor = "#25D366";
                                                              e.target.style.transform = "scale(1)";
                                                              e.target.style.boxShadow = "0 4px 15px rgba(37, 211, 102, 0.4)";
                                                            }}
                                                          >
                                                            💳 Pay Now
                                                          </button>
                                                          <p style={{
                                                            marginTop: "12px",
                                                            fontSize: "13px",
                                                            color: "#666",
                                                            fontStyle: "italic",
                                                            marginBottom: "0"
                                                          }}>
                                                            Click to open Paytm, PhonePe, Google Pay or any UPI app
                                                          </p>
                                                        </div>
                                                      )} */}
                                                    </>
                                                  )}

                                                {/* Special case for auction_id 54158 */}
                                                {localStorage.getItem(
                                                  "auction_id"
                                                ) == 54158 && (
                                                    <>
                                                      <QRSectionTitle>
                                                        Please transfer
                                                        Registration fee{" "}
                                                        <span
                                                          style={{
                                                            fontSize: "1.4rem",
                                                            fontWeight: "bold",
                                                            color: "#689F38",
                                                          }}
                                                        >
                                                          £15{" "}
                                                        </span>{" "}
                                                        to the following account{" "}
                                                      </QRSectionTitle>
                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          Beneficiary:
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          MANDHI SOUQ LTD
                                                        </QRDetailValue>
                                                      </QRDetailRow>

                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          Sort code:
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          043606
                                                        </QRDetailValue>
                                                      </QRDetailRow>

                                                      <QRDetailRow>
                                                        <QRDetailLabel width="auto">
                                                          Account number:
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          00190306
                                                        </QRDetailValue>
                                                      </QRDetailRow>
                                                      <QRDetailRow>
                                                        <QRDetailLabel width="auto">
                                                          Registration Fees:
                                                        </QRDetailLabel>
                                                        <QRDetailValue
                                                          style={{
                                                            fontSize: "1.4rem",
                                                            fontWeight: "bold",
                                                            color: "#689F38",
                                                          }}
                                                        >
                                                          £15
                                                        </QRDetailValue>
                                                      </QRDetailRow>
                                                      <QRDetailRow>
                                                        <QRDetailLabel>
                                                          Ref:
                                                        </QRDetailLabel>
                                                        <QRDetailValue>
                                                          Player Name
                                                        </QRDetailValue>
                                                      </QRDetailRow>
                                                    </>
                                                  )}
                                                {localStorage.getItem("auction_id") > 59149 && (
                                                  <>
                                                    <QRSectionTitle>
                                                      Please transfer Registration fee{" "}
                                                      <span
                                                        style={{
                                                          fontSize: "1.4rem",
                                                          fontWeight: "bold",
                                                          color: "#689F38",
                                                        }}
                                                      >

                                                      </span>{" "}
                                                      to the following account
                                                    </QRSectionTitle>

                                                    {pyqr.pydetail && (
                                                      <>
                                                        <div
                                                          style={{
                                                            marginTop: "10px",
                                                            whiteSpace: "pre-line",
                                                            fontSize: "14px",
                                                            color: "#444",
                                                          }}
                                                          dangerouslySetInnerHTML={{ __html: pyqr.pydetail }}
                                                        ></div>
                                                        {localStorage.getItem("auction_id") == 62590 && (
                                                          <div
                                                            style={{
                                                              marginTop: "10px",
                                                              fontSize: "14px",
                                                              color: "#444",
                                                              fontWeight: "600",
                                                            }}
                                                          >
                                                            Registration Fees: ₹800/₹1000
                                                          </div>
                                                        )}
                                                        {pyqr.fee != null && pyqr.fee !== "" && String(pyqr.fee).trim() !== "" && localStorage.getItem("auction_id") != 62590 && (
                                                          <div
                                                            style={{
                                                              marginTop: "10px",
                                                              fontSize: "14px",
                                                              color: "#444",
                                                              fontWeight: "600",
                                                            }}
                                                          >
                                                            Registration Fees: {String(pyqr.fee).trim().startsWith("₹") ? pyqr.fee : `₹${pyqr.fee}`}
                                                          </div>
                                                        )}
                                                      </>
                                                    )}

                                                    {/* Pay Now Button for auction_id 61248 - Mobile Only */}
                                                    {/* {isMobileOnly && localStorage.getItem("auction_id") == "61248" && (
                                                      <div style={{ marginTop: "25px", textAlign: "center", padding: "15px" }}>
                                                        <button
                                                          type="button"
                                                          onClick={handlePayNow}
                                                          style={{
                                                            backgroundColor: "#25D366",
                                                            color: "white",
                                                            padding: "16px 40px",
                                                            fontSize: "18px",
                                                            fontWeight: "bold",
                                                            border: "none",
                                                            borderRadius: "12px",
                                                            cursor: "pointer",
                                                            boxShadow: "0 4px 15px rgba(37, 211, 102, 0.4)",
                                                            transition: "all 0.3s ease",
                                                            width: "100%",
                                                            maxWidth: "350px",
                                                            display: "inline-block",
                                                          }}
                                                          onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = "#20BA5A";
                                                            e.target.style.transform = "scale(1.05)";
                                                            e.target.style.boxShadow = "0 6px 20px rgba(37, 211, 102, 0.5)";
                                                          }}
                                                          onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = "#25D366";
                                                            e.target.style.transform = "scale(1)";
                                                            e.target.style.boxShadow = "0 4px 15px rgba(37, 211, 102, 0.4)";
                                                          }}
                                                        >
                                                          💳 Pay Now
                                                        </button>
                                                        <p style={{
                                                          marginTop: "12px",
                                                          fontSize: "13px",
                                                          color: "#666",
                                                          fontStyle: "italic",
                                                          marginBottom: "0"
                                                        }}>
                                                          Click to open Paytm, PhonePe, Google Pay or any UPI app
                                                        </p>
                                                      </div>
                                                    )} */}
                                                  </>
                                                )}
                                              </QRDetailsWrapper>
                                            </QRContainer>

                                            {/* Pay Now Button - Phone view only, when pyqr.mob (UPI ID) is available */}
                                            {/* {isMobileOnly && pyqr && pyqr.mob && String(pyqr.mob).trim() !== "" && (
                                              <div style={{ marginTop: "25px", textAlign: "center", padding: "15px" }}>
                                                <button
                                                  type="button"
                                                  onClick={handlePayNow}
                                                  style={{
                                                    backgroundColor: "#25D366",
                                                    color: "white",
                                                    padding: "16px 40px",
                                                    fontSize: "18px",
                                                    fontWeight: "bold",
                                                    border: "none",
                                                    borderRadius: "12px",
                                                    cursor: "pointer",
                                                    boxShadow: "0 4px 15px rgba(37, 211, 102, 0.4)",
                                                    transition: "all 0.3s ease",
                                                    width: "100%",
                                                    maxWidth: "350px",
                                                    display: "inline-block",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = "#20BA5A";
                                                    e.target.style.transform = "scale(1.05)";
                                                    e.target.style.boxShadow = "0 6px 20px rgba(37, 211, 102, 0.5)";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = "#25D366";
                                                    e.target.style.transform = "scale(1)";
                                                    e.target.style.boxShadow = "0 4px 15px rgba(37, 211, 102, 0.4)";
                                                  }}
                                                >
                                                  💳 Pay Now
                                                </button>
                                                <p style={{
                                                  marginTop: "12px",
                                                  fontSize: "13px",
                                                  color: "#666",
                                                  fontStyle: "italic",
                                                  marginBottom: "0"
                                                }}>
                                                  Click to open Paytm, PhonePe, Google Pay or any UPI app
                                                </p>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      )}


                                    {paymentData && (paymentData.pyqr || paymentData.platforminfo) && (() => {
                                      const raw = paymentData.platforminfo?.utrno ?? paymentData.pyqr?.utrno;
                                      const utrno = typeof raw === "string" ? (() => { try { return JSON.parse(raw); } catch (e) { return null; } })() : raw;
                                      if (!utrno || String(utrno.s) !== "1") return null;
                                      return (
                                        <div className="col-md-12 no-side-padd" key="utrno">
                                          <div className="form-group text-box-margin">
                                            <label htmlFor="utrno" className="joinauc-label">
                                              {utrno.l && String(utrno.l).trim() !== ""
                                                ? utrno.l.charAt(0).toUpperCase() + utrno.l.slice(1)
                                                : "UTR No."}
                                              {utrno.r == "1" && "*"}
                                            </label>
                                            <input
                                              type={utrno.t == "1" ? "number" : "text"}
                                              className="form-control joinauc-control"
                                              id="utrno"
                                              placeholder={utrno.p || utrno.l || "UTR No."}
                                              style={{ width: isMobileOnly ? "100%" : "50%" }}
                                              {...register("utrno", {
                                                required: utrno.r == "1" ? "This is required" : false,
                                              })}
                                            />
                                            {errors.utrno && (
                                              <p className="text-error">{errors.utrno.message}</p>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })()}

                                    {data && data.show.receipt.show == 1 && (
                                      <div className="col-md-6 no-side-padd">
                                        <div className="form-group text-box-margin receipt-box">
                                          <label
                                            htmlFor="reciept"
                                            className="receipt-label joinauc-label"
                                          >
                                            {data.show.receipt.label !== ""
                                              ? data.show.receipt.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.receipt.label.slice(1)
                                              : "Receipt"}
                                            {data.show.receipt.req == "1" && (
                                              <span className="required-asterisk">
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <div
                                            className="file-upload-container"
                                            style={
                                              selectedReceiptFile
                                                ? {
                                                  borderColor: "#2e7d32",
                                                  backgroundColor: "#e8f5e9",
                                                }
                                                : {}
                                            }
                                          >
                                            <div className="upload-icon">
                                              <AiIcons.AiOutlineCloudUpload
                                                size={30}
                                              />
                                            </div>

                                            {selectedReceiptFile ? (
                                              <div className="file-preview">
                                                <p className="file-name">
                                                  {selectedReceiptFile.name}
                                                </p>
                                                {selectedReceiptFile.type.startsWith(
                                                  "image/"
                                                ) && (
                                                    <img
                                                      src={URL.createObjectURL(
                                                        selectedReceiptFile
                                                      )}
                                                      alt="Receipt preview"
                                                      style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100px",
                                                        marginTop: "10px",
                                                        borderRadius: "4px",
                                                        boxShadow:
                                                          "0 2px 5px rgba(0,0,0,0.1)",
                                                      }}
                                                    />
                                                  )}
                                              </div>
                                            ) : (
                                              <p className="upload-text">
                                                Drag & drop or click to select
                                                file
                                              </p>
                                            )}

                                            <input
                                              id="receipt-file-input"
                                              placeholder={
                                                data.show.receipt.pholder ||
                                                "Receipt"
                                              }
                                              className="file-input"
                                              type="file"
                                              accept="image/*"
                                              {...register("receipt", {
                                                required:
                                                  data.show.receipt.req == 1
                                                    ? "This is required"
                                                    : false,
                                                onChange: (e) => {
                                                  if (
                                                    e.target.files &&
                                                    e.target.files[0]
                                                  ) {
                                                    const file =
                                                      e.target.files[0];
                                                    const MAX_SIZE =
                                                      2 * 1024 * 1024; // 2 MB in bytes

                                                    if (file.size > MAX_SIZE) {
                                                      toast.error(
                                                        "File size must be 2MB or less",
                                                        {
                                                          theme: "colored",
                                                          position:
                                                            "bottom-center",
                                                        }
                                                      );
                                                      e.target.value = "";
                                                      setSelectedReceiptFile(
                                                        null
                                                      );
                                                      return;
                                                    }

                                                    setSelectedReceiptFile(
                                                      file
                                                    );
                                                  } else {
                                                    setSelectedReceiptFile(
                                                      null
                                                    );
                                                  }
                                                },
                                              })}
                                            />
                                            <p className="file-size-limit">
                                              Maximum file size: 2MB
                                            </p>
                                          </div>
                                          {errors.receipt && (
                                            <p className="error-message">
                                              {errors.receipt.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {data && data.show.receipt.show == 1 && (
                                      <div className="col-md-12 receipt-message-div no-side-padd">
                                        <div className="receipt-message">
                                          {data.show.receipt.pholder !== ""
                                            ? data.show.receipt.pholder
                                            : ""}
                                        </div>
                                      </div>
                                    )}

                                    {localStorage.getItem("auction_id") ==
                                      38524 && (
                                        <div className="qr-container col-md-6 no-side-padd">
                                          <img src={qr1} alt="" />
                                          <p>
                                            <b>Registration fees : 800/-</b>
                                          </p>
                                        </div>
                                      )}
                                    <div className="col-md-12 no-side-padd">
                                      {localStorage.getItem("auction_id") ==
                                        37866 ? (
                                        <>
                                          <h4>
                                            IMPORTANT NOTES BEFORE YOU REGISTER.
                                          </h4>
                                          <p>
                                            1. Player Registration Fee is
                                            Rs.2500/- .
                                          </p>
                                          <p>
                                            2. No Refund After Registration.
                                          </p>
                                          <p>
                                            3. Auction Related Information will
                                            be shared On JSCA Information Group
                                            Only.
                                          </p>
                                          <p>
                                            4. Last Date Of Submission - 18
                                            December 2024.{" "}
                                          </p>
                                          <p>
                                            Tournament Dates : 2 March 2025, 9
                                            March 2025, 16 March 2025, 23 March
                                            2025.
                                          </p>
                                          <p>
                                            <b>
                                              5. Please make sure you are
                                              available for the tournament on
                                              the dates mentioned above then
                                              register.
                                            </b>
                                          </p>

                                          <p>
                                            <input
                                              type="checkbox"
                                              required
                                              style={{
                                                "min-height": "20px",
                                                "margin-right": "10px",
                                              }}
                                            />
                                            I read and agree above points and
                                            want to join.
                                          </p>
                                        </>
                                      ) : (
                                        <p>
                                          <input
                                            type="checkbox"
                                            required
                                            style={{
                                              "min-height": "20px",
                                              "margin-right": "10px",
                                            }}
                                          />
                                          Yes , I want to join.
                                        </p>
                                      )}

                                      <button
                                        className="button joinauc-margtop joinaucbtn-pad"
                                        type="submit"
                                        disabled={isSubmitting}
                                        style={{
                                          width: "100%",
                                          opacity: isSubmitting ? 0.7 : 1,
                                          pointerEvents: isSubmitting
                                            ? "none"
                                            : "auto",
                                        }}
                                      >
                                        {localStorage.getItem("auction_id") === "60397"
                                          ? "Submit"
                                          : isSubmitting
                                            ? "Joining..."
                                            : "Join Auction"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <NotFound data={""} />
      )}
    </div>
  );
}
